window.MAFE_CBD_MENU = {
  "importedAt": "2026-10-14",
  "source": "https://mafebento.eposqr.com/menu/products",
  "packagingFee": 0.5,
  "availabilityByDate": {},
  "foods": [
    {
      "id": "epos-001",
      "cat": "staple",
      "name": "日本珍珠米",
      "en": "Pearl Rice",
      "price": 1,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-pearl-rice-wooden-tub-reference.png?v=1792224985",
      "sourceName": "日本珍珠米 Pearl Rice",
      "sourcePrice": 1,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 130,
        "proteinG": 2.36,
        "fiberG": 0.4,
        "servingGrams": 200,
        "servingGramsRange": [
          50,
          250
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "base",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "selected_base_weight",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "medium",
        "rangePer100g": {
          "kcal": [
            115,
            145
          ],
          "proteinG": [
            2.1,
            2.6
          ],
          "fiberG": [
            0.3,
            0.5
          ]
        },
        "assumptionsZh": [
          "无油熟珍珠米；实际含水率不同。较干情景另用熟米营养浓缩10%作敏感性分析。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": null,
        "calculationValuesPer100g": {
          "kcal": 130,
          "proteinG": 2.36,
          "fiberG": 0.4
        },
        "perSelectedBaseWeight": {
          "50": {
            "kcal": 65,
            "proteinG": 1.2,
            "fiberG": 0.2
          },
          "100": {
            "kcal": 130,
            "proteinG": 2.4,
            "fiberG": 0.4
          },
          "200": {
            "kcal": 260,
            "proteinG": 4.7,
            "fiberG": 0.8
          },
          "250": {
            "kcal": 325,
            "proteinG": 5.9,
            "fiberG": 1
          }
        },
        "displayValuesPer100g": {
          "kcal": 130,
          "proteinG": 2.4,
          "fiberG": 0.4
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageSourceType": "ai_reference",
      "imageSource": {
        "type": "ai_reference",
        "shopifyFileId": "gid://shopify/MediaImage/46508590661874",
        "instruction": "Owner requested missing-image completion and matching wooden rice vessel; draft reference illustration, not a measured serving",
        "libraryFileId": "libfile_b76e4a87c8808191aaf9e63cf0bbef1b"
      }
    },
    {
      "id": "epos-002",
      "cat": "staple",
      "name": "三色糙米",
      "en": "Three-Colour Brown Rice",
      "price": 2,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-tricolour-brown-rice-landscape-v1.png?v=1792205203",
      "sourceName": "三色糙米 Brown Rice",
      "sourcePrice": 2,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 123,
        "proteinG": 2.74,
        "fiberG": 1.6,
        "servingGrams": 200,
        "servingGramsRange": [
          50,
          250
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "base",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "selected_base_weight",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            110,
            145
          ],
          "proteinG": [
            2.3,
            3.2
          ],
          "fiberG": [
            1.6,
            1.9
          ]
        },
        "assumptionsZh": [
          "暂按全糙米近似；三色米配比未知，未证实全部是全谷物。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": null,
        "calculationValuesPer100g": {
          "kcal": 123,
          "proteinG": 2.74,
          "fiberG": 1.6
        },
        "perSelectedBaseWeight": {
          "50": {
            "kcal": 60,
            "proteinG": 1.4,
            "fiberG": 0.8
          },
          "100": {
            "kcal": 125,
            "proteinG": 2.7,
            "fiberG": 1.6
          },
          "200": {
            "kcal": 245,
            "proteinG": 5.5,
            "fiberG": 3.2
          },
          "250": {
            "kcal": 310,
            "proteinG": 6.8,
            "fiberG": 4
          }
        },
        "displayValuesPer100g": {
          "kcal": 125,
          "proteinG": 2.7,
          "fiberG": 1.6
        }
      },
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_d14188f546848191835344f59c4d14d6",
        "shopifyFileId": "gid://shopify/MediaImage/46505118925042",
        "sourceSha256": "5a7b78e1c806d2bebea1c9e24b492873854c03eccaec353c067f835ca6473adc",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-owner-epos-002-20261016.jpg?v=1792154070",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference"
    },
    {
      "id": "epos-003",
      "cat": "staple",
      "name": "炒米粉",
      "en": "Fried Vermicelli",
      "price": 2,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-epos-003-beehoon-no-shrimp-v2.png?v=1792214046",
      "sourceName": "炒米粉 Fried Vermicelli",
      "sourcePrice": 2,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 143.69,
        "proteinG": 1.8471,
        "fiberG": 0.979,
        "servingGrams": 200,
        "servingGramsRange": [
          50,
          250
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "base",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "selected_base_weight",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            115,
            180
          ],
          "proteinG": [
            1.8,
            2
          ],
          "fiberG": [
            0.9,
            1.1
          ]
        },
        "assumptionsZh": [
          "假设是素炒米粉，不含肉、蛋或虾；若实际含这些配料需更新。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": null,
        "calculationValuesPer100g": {
          "kcal": 143.69,
          "proteinG": 1.8471,
          "fiberG": 0.979
        },
        "perSelectedBaseWeight": {
          "50": {
            "kcal": 70,
            "proteinG": 0.9,
            "fiberG": 0.5
          },
          "100": {
            "kcal": 145,
            "proteinG": 1.8,
            "fiberG": 1
          },
          "200": {
            "kcal": 285,
            "proteinG": 3.7,
            "fiberG": 2
          },
          "250": {
            "kcal": 360,
            "proteinG": 4.6,
            "fiberG": 2.4
          }
        },
        "displayValuesPer100g": {
          "kcal": 145,
          "proteinG": 1.8,
          "fiberG": 1
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "imageSource": {
        "kind": "owner-approved-ai-revision",
        "libraryFileId": "libfile_456c660e9fd48191914d5718e7329a13",
        "shopifyMediaId": "gid://shopify/MediaImage/46506373578994",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_a675c33ac8648191949732cfa4acdd0c",
        "note": "No shrimp depicted. Serving illustration, not selected portion size."
      },
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference"
    },
    {
      "id": "epos-004",
      "cat": "staple",
      "name": "地瓜粥",
      "en": "Sweet Potato Congee",
      "price": 1.5,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-004-confirmed-lotus-v1.png?v=1792205579",
      "sourceName": "Congee",
      "sourcePrice": 1.5,
      "nutrition": {
        "basis": "per_100g",
        "status": "recipe_unconfirmed",
        "labelZh": "营养待确认",
        "kcal": 39,
        "proteinG": 0.708,
        "fiberG": 0.12,
        "servingGrams": 200,
        "servingGramsRange": [
          50,
          250
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "base",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "selected_base_weight",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            25,
            60
          ],
          "proteinG": [
            0.4,
            1.1
          ],
          "fiberG": [
            0,
            0.2
          ]
        },
        "assumptionsZh": [
          "假设清白粥，以熟米饭加水稀释；不含肉、蛋、油。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": null,
        "calculationValuesPer100g": {
          "kcal": 39,
          "proteinG": 0.708,
          "fiberG": 0.12
        },
        "perSelectedBaseWeight": {
          "50": {
            "kcal": 20,
            "proteinG": 0.4,
            "fiberG": 0.1
          },
          "100": {
            "kcal": 40,
            "proteinG": 0.7,
            "fiberG": 0.1
          },
          "200": {
            "kcal": 80,
            "proteinG": 1.4,
            "fiberG": 0.2
          },
          "250": {
            "kcal": 100,
            "proteinG": 1.8,
            "fiberG": 0.3
          }
        },
        "displayValuesPer100g": {
          "kcal": 40,
          "proteinG": 0.7,
          "fiberG": 0.1
        },
        "pendingReason": "Sweet potato-to-rice/water ratio pending; previous plain-rice congee estimate retained for audit only, not counted.",
        "pendingReasonZh": "地瓜与米、水比例待确认；旧白粥估算仅保留供核查，不计入营养总数。",
        "recipeChangeSourceMessageId": "Sentinel_f64d726a5030819189e91810d7d672a5"
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_3f1702b77ad88191982370162cff30bc",
        "shopifyFileId": "gid://shopify/MediaImage/46505134784754",
        "sourceSha256": "d0dde7a24d4df9d297c5f8907ad581cb41237251c19e370f209385471a505156",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-005",
      "cat": "egg",
      "name": "枸杞鸡蛋焖娃娃菜",
      "en": "Braised Baby Cabbage with Egg & Goji Berries",
      "price": 2.5,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-005-lotus-plate-v2.png?v=1792205229",
      "sourceName": "枸杞鸡蛋焖娃娃菜 Braised Baby Cabbage with Egg & Goji Berries",
      "sourcePrice": 2.5,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 79.965,
        "proteinG": 5.2035,
        "fiberG": 0.421,
        "servingGrams": 135,
        "servingGramsRange": [
          120,
          150
        ],
        "servingRangeBasis": "Owner-specific override: 005 and 011 total dish with broth 120–150 g, midpoint 135 g; 030 approximately 50 g per piece, not a measured exact weight",
        "servingAssumptionCategory": "special_saucy_dish",
        "servingInstructionMessageId": "Sentinel_d27e68f8e2b481919262aad0dd7ac41d",
        "servingWeightStatus": "owner_specific_range_midpoint_with_sauce",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            50,
            120
          ],
          "proteinG": [
            3.5,
            6.9
          ],
          "fiberG": [
            0.3,
            0.6
          ]
        },
        "assumptionsZh": [
          "同一道枸杞鸡蛋娃娃菜，用户补充为上汤带汁版本120–150g，仍保留蛋比菜多的信息。模型每100g含蛋25–45g、娃娃菜20–25g，其余含22–52.7g清汤/水及调料；不是把135g都当蛋或固形物。汤底用通用清汤代理，仅作营养估算，不是实际汤底或过敏原确认。",
          "按整份含汁135g计算，来自用户120–150g区间中点；假设吃下模型中全部汤汁，剩汤会改变摄入量。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 135,
          "kcal": 110,
          "proteinG": 7,
          "fiberG": 0.6,
          "range": {
            "kcal": [
              60,
              180
            ],
            "proteinG": [
              4.2,
              10.4
            ],
            "fiberG": [
              0.4,
              0.9
            ]
          },
          "labelZh": "AI预估，按约135g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 79.965,
          "proteinG": 5.2035,
          "fiberG": 0.421
        },
        "displayValuesPer100g": {
          "kcal": 80,
          "proteinG": 5.2,
          "fiberG": 0.4
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-005.jpg?v=1791937288",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_b2182ef06d00819191e251a0c39e7c71",
        "shopifyFileId": "gid://shopify/MediaImage/46505120661746",
        "sourceSha256": "e69d2a35ca7ae03c2750385e3184f21858837878d9b06cbf811a0477065deb0a",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-006",
      "cat": "veg",
      "name": "蚝油蒸秋葵",
      "en": "Steamed Okra with Oyster Sauce",
      "price": 2,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-006-neat-ceramic-v3.png?v=1792205175",
      "sourceName": "蚝油蒸秋葵 Steam Orka with Osyter Sauce",
      "sourcePrice": 2,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 40.61,
        "proteinG": 1.7401,
        "fiberG": 2.221,
        "servingGrams": 80,
        "servingGramsRange": [
          80,
          80
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "dish",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "owner_requested_assumed_80g",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            20,
            70
          ],
          "proteinG": [
            1.6,
            1.9
          ],
          "fiberG": [
            2,
            2.4
          ]
        },
        "assumptionsZh": [
          "熟秋葵加蚝油，额外油0–5g/100g。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 80,
          "kcal": 30,
          "proteinG": 1.4,
          "fiberG": 1.8,
          "range": {
            "kcal": [
              15,
              55
            ],
            "proteinG": [
              1.3,
              1.5
            ],
            "fiberG": [
              1.6,
              1.9
            ]
          },
          "labelZh": "AI预估，按约80g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 40.61,
          "proteinG": 1.7401,
          "fiberG": 2.221
        },
        "displayValuesPer100g": {
          "kcal": 40,
          "proteinG": 1.7,
          "fiberG": 2.2
        }
      },
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_c373baf9a6008191a504216f1ce77d2e",
        "shopifyFileId": "gid://shopify/MediaImage/46505117516018",
        "sourceSha256": "5ca8983904d9501c70498c7d2baa84654a333d1f64e98cf5b964c2786cd589e1",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 1,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": null,
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "sourceOwnerQuote": "这个🌶️一根辣度",
        "confirmedAt": "2026-10-16"
      },
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageReferenceLabelEn": "AI-enhanced reference image",
      "imageReferenceLabelZh": "AI修饰参考图",
      "imageAspect": "3:2",
      "imageKind": "reference",
      "originalImage": "images/steamed-okra-landscape-v1.png"
    },
    {
      "id": "epos-007",
      "cat": "veg",
      "name": "虾米炒秋葵",
      "en": "Stir-Fried Okra with Dried Shrimp",
      "price": 2,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-007-dried-shrimp-okra-landscape-v1.png?v=1792205112",
      "sourceName": "虾米炒秋葵 Stir-Fried Okra with Dried Shrimp",
      "sourcePrice": 2,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 73.63,
        "proteinG": 3.2906,
        "fiberG": 2.216,
        "servingGrams": 80,
        "servingGramsRange": [
          80,
          80
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "dish",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "owner_requested_assumed_80g",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            45,
            120
          ],
          "proteinG": [
            2.8,
            4.6
          ],
          "fiberG": [
            2,
            2.4
          ]
        },
        "assumptionsZh": [
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "cfs_food_search",
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 80,
          "kcal": 60,
          "proteinG": 2.6,
          "fiberG": 1.8,
          "range": {
            "kcal": [
              35,
              95
            ],
            "proteinG": [
              2.2,
              3.7
            ],
            "fiberG": [
              1.6,
              1.9
            ]
          },
          "labelZh": "AI预估，按约80g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 73.63,
          "proteinG": 3.2906,
          "fiberG": 2.216
        },
        "displayValuesPer100g": {
          "kcal": 75,
          "proteinG": 3.3,
          "fiberG": 2.2
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 1,
        "sourceMessageId": "Sentinel_f64d726a5030819189e91810d7d672a5",
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-007.jpg?v=1791937309",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_86897f98924c8191b7a71eb8d5c620f3",
        "shopifyFileId": "gid://shopify/MediaImage/46505113682162",
        "sourceSha256": "064422e73b882789de01c55da27309598fdf1a4470e6acfda130a003810287cc",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-008",
      "cat": "veg",
      "name": "红烧茄子",
      "en": "Braised Eggplant",
      "price": 2,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-008-braised-eggplant-landscape-v1.png?v=1792205124",
      "sourceName": "红烧茄子 Braised Eggplant",
      "sourcePrice": 2,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 128.08,
        "proteinG": 1.1194,
        "fiberG": 2.083,
        "servingGrams": 80,
        "servingGramsRange": [
          80,
          80
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "dish",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "owner_requested_assumed_80g",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            75,
            200
          ],
          "proteinG": [
            1,
            1.2
          ],
          "fiberG": [
            1.8,
            2.3
          ]
        },
        "assumptionsZh": [
          "茄子吸油量尤其不确定；模型保留油4–16g/100g。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 80,
          "kcal": 100,
          "proteinG": 0.9,
          "fiberG": 1.7,
          "range": {
            "kcal": [
              60,
              160
            ],
            "proteinG": [
              0.8,
              0.9
            ],
            "fiberG": [
              1.4,
              1.8
            ]
          },
          "labelZh": "AI预估，按约80g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 128.08,
          "proteinG": 1.1194,
          "fiberG": 2.083
        },
        "displayValuesPer100g": {
          "kcal": 130,
          "proteinG": 1.1,
          "fiberG": 2.1
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-008.jpg?v=1791937320",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_1b3d8d9370a8819187414f16141e339f",
        "shopifyFileId": "gid://shopify/MediaImage/46505114304754",
        "sourceSha256": "d4652c271a9ba212338542cb344b6e0a128c6dc4072c852cea098321b09c7194",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-009",
      "cat": "veg",
      "name": "咸鱼炒豆芽",
      "en": "Stir-Fried Salted Fish with Bean Sprouts",
      "price": 2,
      "available": true,
      "image": "",
      "sourceName": "咸鱼炒豆芽 Stir-Fried Salted Fish with Bean Sprouts",
      "sourcePrice": 2,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 99.94,
        "proteinG": 5.872,
        "fiberG": 1.692,
        "servingGrams": 80,
        "servingGramsRange": [
          80,
          80
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "dish",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "owner_requested_assumed_80g",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            70,
            145
          ],
          "proteinG": [
            5.1,
            7.6
          ],
          "fiberG": [
            1.5,
            1.8
          ]
        },
        "assumptionsZh": [
          "咸鱼种类和浸泡程度不明，采用干盐渍鳕鱼作为营养代理。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 80,
          "kcal": 80,
          "proteinG": 4.7,
          "fiberG": 1.4,
          "range": {
            "kcal": [
              55,
              115
            ],
            "proteinG": [
              4.1,
              6.1
            ],
            "fiberG": [
              1.2,
              1.5
            ]
          },
          "labelZh": "AI预估，按约80g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 99.94,
          "proteinG": 5.872,
          "fiberG": 1.692
        },
        "displayValuesPer100g": {
          "kcal": 100,
          "proteinG": 5.9,
          "fiberG": 1.7
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "withdrawnImage": {
        "url": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-salted-fish-bean-sprouts-lotus-reference.png?v=1792225406",
        "sourceMessageId": "Sentinel_09b935a3db808191822c5925cc542d4d",
        "reason": "Owner requested removing this food photo; retain dish and text until replacement approved."
      }
    },
    {
      "id": "epos-010",
      "cat": "veg",
      "name": "西芹炒木耳",
      "en": "Stir Fried Celery with Wood Ear Mushroom",
      "price": 2,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-celery-wood-ear-lotus-reference.png?v=1792225419",
      "sourceName": "西芹炒木耳 Stir Fried Celery with Wood Ear Mushroom",
      "sourcePrice": 2,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 67.012,
        "proteinG": 1.0672,
        "fiberG": 2.7583,
        "servingGrams": 80,
        "servingGramsRange": [
          80,
          80
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "dish",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "owner_requested_assumed_80g",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            40,
            105
          ],
          "proteinG": [
            1,
            1.2
          ],
          "fiberG": [
            2.5,
            3.3
          ]
        },
        "assumptionsZh": [
          "木耳采用10倍泡发假设。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 80,
          "kcal": 55,
          "proteinG": 0.9,
          "fiberG": 2.2,
          "range": {
            "kcal": [
              30,
              85
            ],
            "proteinG": [
              0.8,
              1
            ],
            "fiberG": [
              2,
              2.6
            ]
          },
          "labelZh": "AI预估，按约80g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 67.012,
          "proteinG": 1.0672,
          "fiberG": 2.7583
        },
        "displayValuesPer100g": {
          "kcal": 65,
          "proteinG": 1.1,
          "fiberG": 2.8
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageSourceType": "ai_reference",
      "imageSource": {
        "type": "ai_reference",
        "fileId": "gid://shopify/MediaImage/46508647907570",
        "instruction": "Original illustrative dish image using accepted lotus plate; not a measured serving photograph."
      }
    },
    {
      "id": "epos-011",
      "cat": "veg",
      "name": "罗汉斋",
      "en": "Braised Mixed Vegetables",
      "price": 3,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-011-lotus-plate-v2.png?v=1792205241",
      "sourceName": "罗汉斋 Braised Mixed Vegetables",
      "sourcePrice": 3,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 84.2,
        "proteinG": 4.0895,
        "fiberG": 1.7125,
        "servingGrams": 135,
        "servingGramsRange": [
          120,
          150
        ],
        "servingRangeBasis": "Owner-specific override: 005 and 011 total dish with broth 120–150 g, midpoint 135 g; 030 approximately 50 g per piece, not a measured exact weight",
        "servingAssumptionCategory": "special_saucy_dish",
        "servingInstructionMessageId": "Sentinel_d27e68f8e2b481919262aad0dd7ac41d",
        "servingWeightStatus": "owner_specific_range_midpoint_with_sauce",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            45,
            155
          ],
          "proteinG": [
            2.4,
            7.4
          ],
          "fiberG": [
            1.4,
            1.8
          ]
        },
        "assumptionsZh": [
          "用户已确认豆皮及几种蔬菜、含汁总份量120–150g。中央每100g暂设泡发非油炸腐皮20g、熟混合蔬菜55g、清汤17g、油3g、酱油3g及淀粉2g；配菜种类和比例均为情景假设，不是厨师配方。豆皮10–30g/100g、保留油1–7g/100g用于区间；若实际是千张或先炸豆皮须重算，不假定另含粉丝或其他豆制品。",
          "按整份含汁135g计算，来自用户120–150g区间中点；假设吃下模型中全部汤汁，剩汤会改变摄入量。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "mext_yuba_2023",
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 135,
          "kcal": 115,
          "proteinG": 5.5,
          "fiberG": 2.3,
          "range": {
            "kcal": [
              55,
              235
            ],
            "proteinG": [
              2.9,
              11.1
            ],
            "fiberG": [
              1.7,
              2.6
            ]
          },
          "labelZh": "AI预估，按约135g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 84.2,
          "proteinG": 4.0895,
          "fiberG": 1.7125
        },
        "displayValuesPer100g": {
          "kcal": 85,
          "proteinG": 4.1,
          "fiberG": 1.7
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-011.jpg?v=1791937331",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_917aa8ed03f48191a7a3e3aeed87aa3c",
        "shopifyFileId": "gid://shopify/MediaImage/46505121120498",
        "sourceSha256": "23da1f5c55e0c7a2ca771ddd80d5ffc7011b766848e530555a033f891c6bf18c",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-012",
      "cat": "veg",
      "name": "三蛋苋菜",
      "en": "Braised Amaranth with Three Eggs",
      "price": 2,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-healthy-three-egg-amaranth-landscape-v1.png?v=1792172200",
      "sourceName": "三蛋苋菜 Braised Amaranth with Three Eggs",
      "sourcePrice": 2,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 78.39,
        "proteinG": 4.4083,
        "fiberG": 1.316,
        "servingGrams": 80,
        "servingGramsRange": [
          80,
          80
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "dish",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "owner_requested_assumed_80g",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            45,
            130
          ],
          "proteinG": [
            3.3,
            6.2
          ],
          "fiberG": [
            0.9,
            1.6
          ]
        },
        "assumptionsZh": [
          "三蛋暂指鸡蛋、咸鸭蛋、皮蛋；比例未核实，菜仍按原蔬菜分类。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "cfs_food_search",
          "cfs_vegetables_2007",
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 80,
          "kcal": 65,
          "proteinG": 3.5,
          "fiberG": 1.1,
          "range": {
            "kcal": [
              35,
              105
            ],
            "proteinG": [
              2.6,
              5
            ],
            "fiberG": [
              0.7,
              1.3
            ]
          },
          "labelZh": "AI预估，按约80g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 78.39,
          "proteinG": 4.4083,
          "fiberG": 1.316
        },
        "displayValuesPer100g": {
          "kcal": 80,
          "proteinG": 4.4,
          "fiberG": 1.3
        }
      },
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_3731114b42988191bbe8e86d9c289785",
        "shopifyFileId": "gid://shopify/MediaImage/46500635181298",
        "sourceSha256": "c3e2479a35341e31412b34589c66772a0ff689a114a9ea935b923f4fb47d0c72",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageReferenceLabelEn": "AI-enhanced reference image",
      "imageReferenceLabelZh": "AI修饰参考图",
      "imageAspect": "3:2",
      "imageKind": "reference",
      "originalImage": "images/three-egg-amaranth-landscape-v1.png"
    },
    {
      "id": "epos-013",
      "cat": "veg",
      "name": "酸辣土豆丝",
      "en": "Hot & Spicy Shredded Potato",
      "price": 2,
      "available": true,
      "image": "",
      "sourceName": "酸辣土豆丝 Hot & Spicy Shredded Potato",
      "sourcePrice": 2,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 123.82,
        "proteinG": 1.65,
        "fiberG": 1.652,
        "servingGrams": 80,
        "servingGramsRange": [
          80,
          80
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "dish",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "owner_requested_assumed_80g",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            100,
            165
          ],
          "proteinG": [
            1.5,
            1.8
          ],
          "fiberG": [
            1.5,
            1.8
          ]
        },
        "assumptionsZh": [
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 80,
          "kcal": 100,
          "proteinG": 1.3,
          "fiberG": 1.3,
          "range": {
            "kcal": [
              80,
              135
            ],
            "proteinG": [
              1.2,
              1.4
            ],
            "fiberG": [
              1.2,
              1.4
            ]
          },
          "labelZh": "AI预估，按约80g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 123.82,
          "proteinG": 1.65,
          "fiberG": 1.652
        },
        "displayValuesPer100g": {
          "kcal": 125,
          "proteinG": 1.6,
          "fiberG": 1.7
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 1,
        "sourceMessageId": "Sentinel_f64d726a5030819189e91810d7d672a5",
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "withdrawnImage": {
        "url": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-shredded-potato-lotus-reference.png?v=1792225430",
        "sourceMessageId": "Sentinel_09b935a3db808191822c5925cc542d4d",
        "reason": "Owner requested removing this food photo; retain dish and text until replacement approved."
      }
    },
    {
      "id": "epos-014",
      "cat": "veg",
      "name": "爆炒包菜丝",
      "en": "Stir-Fried Shredded Cabbage",
      "price": 2,
      "available": true,
      "image": "",
      "sourceName": "爆炒包菜丝 Stir-Fried Shredded Cabbage",
      "sourcePrice": 2,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 69.24,
        "proteinG": 1.5017,
        "fiberG": 1.757,
        "servingGrams": 80,
        "servingGramsRange": [
          80,
          80
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "dish",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "owner_requested_assumed_80g",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            40,
            110
          ],
          "proteinG": [
            1.4,
            1.6
          ],
          "fiberG": [
            1.6,
            1.9
          ]
        },
        "assumptionsZh": [
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 80,
          "kcal": 55,
          "proteinG": 1.2,
          "fiberG": 1.4,
          "range": {
            "kcal": [
              30,
              85
            ],
            "proteinG": [
              1.1,
              1.3
            ],
            "fiberG": [
              1.3,
              1.5
            ]
          },
          "labelZh": "AI预估，按约80g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 69.24,
          "proteinG": 1.5017,
          "fiberG": 1.757
        },
        "displayValuesPer100g": {
          "kcal": 70,
          "proteinG": 1.5,
          "fiberG": 1.8
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "withdrawnImage": {
        "url": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-shredded-cabbage-lotus-reference.png?v=1792225441",
        "sourceMessageId": "Sentinel_09b935a3db808191822c5925cc542d4d",
        "reason": "Owner requested removing this food photo; retain dish and text until replacement approved."
      }
    },
    {
      "id": "epos-015",
      "cat": "veg",
      "name": "白灼香港菜心",
      "en": "Blanched Choy Sum",
      "price": 2,
      "available": true,
      "image": "",
      "sourceName": "白灼香港菜心 (3 stalks) Blanched Choy Sum",
      "sourcePrice": 2,
      "portionEn": "3 stalks",
      "portionZh": "3 棵",
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 29.23,
        "proteinG": 1.9362,
        "fiberG": 1.904,
        "servingGrams": null,
        "servingGramsRange": [
          80,
          80
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "dish",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "edible_weight_unconfirmed",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            20,
            65
          ],
          "proteinG": [
            1.9,
            2.1
          ],
          "fiberG": [
            1.7,
            2
          ]
        },
        "assumptionsZh": [
          "原售卖规格3棵保留；80g是用户指定的普通菜估算份量，并非已称量3棵熟菜。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。",
          "售卖规格保留3 棵；未将件数/棵数换成已知克数。"
        ],
        "sourceIds": [
          "cfs_food_search",
          "usda_sr_2018"
        ],
        "perServingEstimate": null,
        "calculationValuesPer100g": {
          "kcal": 29.23,
          "proteinG": 1.9362,
          "fiberG": 1.904
        },
        "displayValuesPer100g": {
          "kcal": 30,
          "proteinG": 1.9,
          "fiberG": 1.9
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "withdrawnImage": {
        "url": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-choy-sum-three-stalks-reference.png?v=1792225008",
        "sourceMessageId": "Sentinel_09b935a3db808191822c5925cc542d4d",
        "reason": "Owner requested removing this food photo; retain dish and text until replacement approved."
      }
    },
    {
      "id": "epos-016",
      "cat": "veg",
      "name": "蒜蓉豆苗",
      "en": "Garlic Pea Shoots",
      "price": 2,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-garlic-pea-shoots-reference.png?v=1792225022",
      "sourceName": "蒜蓉豆苗 Garlic Pea Shoots",
      "sourcePrice": 2,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 80.69,
        "proteinG": 4.5358,
        "fiberG": 2.092,
        "servingGrams": 80,
        "servingGramsRange": [
          80,
          80
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "dish",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "owner_requested_assumed_80g",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            50,
            120
          ],
          "proteinG": [
            4.4,
            4.7
          ],
          "fiberG": [
            1.9,
            2.2
          ]
        },
        "assumptionsZh": [
          "豆苗熟制出品率90%为估计，需实秤。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "cfs_food_search",
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 80,
          "kcal": 65,
          "proteinG": 3.6,
          "fiberG": 1.7,
          "range": {
            "kcal": [
              40,
              95
            ],
            "proteinG": [
              3.5,
              3.8
            ],
            "fiberG": [
              1.5,
              1.8
            ]
          },
          "labelZh": "AI预估，按约80g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 80.69,
          "proteinG": 4.5358,
          "fiberG": 2.092
        },
        "displayValuesPer100g": {
          "kcal": 80,
          "proteinG": 4.5,
          "fiberG": 2.1
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageSourceType": "ai_reference",
      "imageSource": {
        "type": "ai_reference",
        "shopifyFileId": "gid://shopify/MediaImage/46508599017714",
        "instruction": "Owner requested missing-image completion and matching wooden rice vessel; draft reference illustration, not a measured serving"
      }
    },
    {
      "id": "epos-017",
      "cat": "veg",
      "name": "干锅有机花菜",
      "en": "Dry Pot Organic Cauliflower",
      "price": 2,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-017-cauliflower-lotus-v2.png?v=1792205514",
      "sourceName": "干锅有机包菜 Dry Pot Organic Cabbage",
      "sourcePrice": 2,
      "nutrition": {
        "basis": "per_100g",
        "status": "recipe_unconfirmed",
        "labelZh": "AI预估",
        "kcal": 94,
        "proteinG": 1.418,
        "fiberG": 1.705,
        "servingGrams": 80,
        "servingGramsRange": [
          80,
          80
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "dish",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "owner_requested_assumed_80g",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            50,
            140
          ],
          "proteinG": [
            1.4,
            1.5
          ],
          "fiberG": [
            1.5,
            1.9
          ]
        },
        "assumptionsZh": [
          "假设不含五花肉；如厨房有肉片，必须另算，不能从菜名保证素食。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 80,
          "kcal": 75,
          "proteinG": 1.1,
          "fiberG": 1.4,
          "range": {
            "kcal": [
              40,
              115
            ],
            "proteinG": [
              1.1,
              1.2
            ],
            "fiberG": [
              1.2,
              1.5
            ]
          },
          "labelZh": "AI预估，按约80g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 94,
          "proteinG": 1.418,
          "fiberG": 1.705
        },
        "displayValuesPer100g": {
          "kcal": 95,
          "proteinG": 1.4,
          "fiberG": 1.7
        },
        "unconfirmedReason": "Owner corrected main ingredient from cabbage to cauliflower; prior cabbage model excluded pending recalculation.",
        "correctionSourceMessageId": "Sentinel_59c0b1f54e7c81918bd642ed31b6c818"
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "nameCorrection": {
        "sourceMessageId": "Sentinel_59c0b1f54e7c81918bd642ed31b6c818",
        "previousName": "干锅有机包菜 Dry Pot Organic Cabbage",
        "note": "Owner corrected cabbage to cauliflower; original sourceName retained for audit only"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-017.jpg?v=1791937342",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_74f30b94ea1481919f597dc5be24134a",
        "shopifyFileId": "gid://shopify/MediaImage/46505132097778",
        "sourceSha256": "f559407629be90960ab824ab6a92f66db853846ddf8ac018f7548f42edc2117d",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-018",
      "cat": "veg",
      "name": "橄榄菜四季豆",
      "en": "Olive Four Seasons Beans",
      "price": 2,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-018-olive-green-beans-landscape-v1.png?v=1792205100",
      "sourceName": "橄榄菜四季豆 Olive Four Seasons Beans",
      "sourcePrice": 2,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 102.072,
        "proteinG": 1.9353,
        "fiberG": 2.837,
        "servingGrams": 80,
        "servingGramsRange": [
          80,
          80
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "dish",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "owner_requested_assumed_80g",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            60,
            160
          ],
          "proteinG": [
            1.8,
            2.1
          ],
          "fiberG": [
            2.5,
            3
          ]
        },
        "assumptionsZh": [
          "暂按无肉末版本；橄榄菜含油差异大。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 80,
          "kcal": 80,
          "proteinG": 1.5,
          "fiberG": 2.3,
          "range": {
            "kcal": [
              50,
              130
            ],
            "proteinG": [
              1.4,
              1.7
            ],
            "fiberG": [
              2,
              2.4
            ]
          },
          "labelZh": "AI预估，按约80g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 102.072,
          "proteinG": 1.9353,
          "fiberG": 2.837
        },
        "displayValuesPer100g": {
          "kcal": 100,
          "proteinG": 1.9,
          "fiberG": 2.8
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-018.jpg?v=1791937352",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_778bd193c1b4819197412267d7eda978",
        "shopifyFileId": "gid://shopify/MediaImage/46505112994034",
        "sourceSha256": "9d212272f8b02b2d232eda183cd7c99c2c3eba2a2f49e165c1d040cf52f2ccf9",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-019",
      "cat": "veg",
      "name": "清炒奶白菜",
      "en": "Stir-Fried Nai Bai",
      "price": 2,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-019-nai-bai-landscape-v1.png?v=1792205137",
      "sourceName": "清炒奶白菜 Stir-Fried Nai Bai",
      "sourcePrice": 2,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 59.16,
        "proteinG": 1.7096,
        "fiberG": 0.968,
        "servingGrams": 80,
        "servingGramsRange": [
          80,
          80
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "dish",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "owner_requested_assumed_80g",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            30,
            100
          ],
          "proteinG": [
            1.6,
            1.9
          ],
          "fiberG": [
            0.9,
            1
          ]
        },
        "assumptionsZh": [
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 80,
          "kcal": 45,
          "proteinG": 1.4,
          "fiberG": 0.8,
          "range": {
            "kcal": [
              25,
              80
            ],
            "proteinG": [
              1.3,
              1.5
            ],
            "fiberG": [
              0.7,
              0.8
            ]
          },
          "labelZh": "AI预估，按约80g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 59.16,
          "proteinG": 1.7096,
          "fiberG": 0.968
        },
        "displayValuesPer100g": {
          "kcal": 60,
          "proteinG": 1.7,
          "fiberG": 1
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-019.jpg?v=1791937363",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_e0ae320e7b648191a7c032c46c924426",
        "shopifyFileId": "gid://shopify/MediaImage/46505115549938",
        "sourceSha256": "6bfb76e089f06aab075b1b692fb518a35e3527058e5d7a4320b972ea9601203e",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-020",
      "cat": "veg",
      "name": "木耳西兰花",
      "en": "Broccoli with Black Fungus",
      "price": 2,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-020-confirmed-lotus-v1.png?v=1792205552",
      "sourceName": "木耳西兰花 Broccoli with Black Fungus",
      "sourcePrice": 2,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 78.902,
        "proteinG": 2.1939,
        "fiberG": 3.7288,
        "servingGrams": 80,
        "servingGramsRange": [
          80,
          80
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "dish",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "owner_requested_assumed_80g",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            50,
            115
          ],
          "proteinG": [
            2,
            2.4
          ],
          "fiberG": [
            3.5,
            3.9
          ]
        },
        "assumptionsZh": [
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 80,
          "kcal": 65,
          "proteinG": 1.8,
          "fiberG": 3,
          "range": {
            "kcal": [
              40,
              95
            ],
            "proteinG": [
              1.6,
              1.9
            ],
            "fiberG": [
              2.8,
              3.1
            ]
          },
          "labelZh": "AI预估，按约80g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 78.902,
          "proteinG": 2.1939,
          "fiberG": 3.7288
        },
        "displayValuesPer100g": {
          "kcal": 80,
          "proteinG": 2.2,
          "fiberG": 3.7
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-020.jpg?v=1791937374",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_49eb7f33586c81919955019e5908286c",
        "shopifyFileId": "gid://shopify/MediaImage/46505133048050",
        "sourceSha256": "47486cbf83d6e04da8f05f9babc5bb437d3675203953cc4329242a8b02c7812a",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-021",
      "cat": "egg",
      "name": "虾仁蒸蛋",
      "en": "Steamed Egg with Shrimp",
      "price": 3,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-021-confirmed-lotus-v1.png?v=1792205539",
      "sourceName": "虾仁蒸蛋 Steamed Egg with Shrimp",
      "sourcePrice": 2,
      "importedImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-021.jpg?v=1791937388",
      "imageReview": "EPOS photo appears to show an omelette; hidden pending confirmation.",
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 93.93,
        "proteinG": 8.5688,
        "fiberG": 0.016,
        "servingGrams": 70,
        "servingGramsRange": [
          60,
          80
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "egg",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "assumed_category_midpoint",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            60,
            145
          ],
          "proteinG": [
            6,
            12.2
          ],
          "fiberG": [
            0,
            0.1
          ]
        },
        "assumptionsZh": [
          "只按当前菜名蒸蛋建模，水约16–57%；图片不能证明配方。若实际煎蛋需重算。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 70,
          "kcal": 65,
          "proteinG": 6,
          "fiberG": 0,
          "range": {
            "kcal": [
              35,
              115
            ],
            "proteinG": [
              3.6,
              9.7
            ],
            "fiberG": [
              0,
              0.1
            ]
          },
          "labelZh": "AI预估，按约70g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 93.93,
          "proteinG": 8.5688,
          "fiberG": 0.016
        },
        "displayValuesPer100g": {
          "kcal": 95,
          "proteinG": 8.6,
          "fiberG": 0
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_cec18375d760819183ee3d9f41e8c48a",
        "shopifyFileId": "gid://shopify/MediaImage/46505132818674",
        "sourceSha256": "9a20511a08fe1481dd730b081b450390f688b0f614defe678e450b22b83500cf",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-022",
      "cat": "egg",
      "name": "肉碎彩豆日本豆腐",
      "en": "Minced Meat with Mixed Beans & Japanese Tofu",
      "price": 2,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-epos-022-approved-landscape-ai-20261016.png?v=1792155825",
      "sourceName": "肉碎彩豆日本豆腐 Minced Pork with Mixed Beans & Japanese Tofu",
      "sourcePrice": 2,
      "nutrition": {
        "basis": "per_100g",
        "status": "pending",
        "labelZh": "待补配方",
        "kcal": null,
        "proteinG": null,
        "fiberG": null,
        "servingGrams": null,
        "servingGramsRange": [
          80,
          80
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "dish",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "owner_requested_assumed_80g",
        "source": null,
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "unknown",
        "rangePer100g": null,
        "assumptionsZh": [
          "请确认日本/蛋豆腐品牌或营养标签、是否先炸、肉末及彩豆比例。"
        ],
        "sourceIds": [],
        "perServingEstimate": null
      },
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_6bc925d02258819182e6b529ff88b189",
        "shopifyFileId": "gid://shopify/MediaImage/46497992966386",
        "sourceSha256": "5b4b18e322914b450563be8b26e1f47b70f4b08d817fb680b6aac7b8bb3eff29",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-owner-epos-022-20261016.jpg?v=1792154057",
      "originalImageSource": {
        "type": "owner_supplied_actual_photo",
        "libraryFileId": "libfile_0e89ba9163b08191b3e2fa5cb10500df",
        "shopifyFileId": "gid://shopify/MediaImage/46497729216754",
        "providedAt": "2026-10-16"
      },
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageReferenceLabelEn": "AI-enhanced reference image",
      "imageReferenceLabelZh": "AI修饰参考图"
    },
    {
      "id": "epos-023",
      "cat": "egg",
      "name": "洋葱煎蛋",
      "en": "Onion Omelette",
      "price": 2,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-023-confirmed-lotus-v1.png?v=1792205566",
      "sourceName": "洋葱煎蛋 Onion Omelette",
      "sourcePrice": 2,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 174.5,
        "proteinG": 9.5068,
        "fiberG": 0.296,
        "servingGrams": 70,
        "servingGramsRange": [
          60,
          80
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "egg",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "assumed_category_midpoint",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            140,
            210
          ],
          "proteinG": [
            8.7,
            10.3
          ],
          "fiberG": [
            0.1,
            0.5
          ]
        },
        "assumptionsZh": [
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 70,
          "kcal": 120,
          "proteinG": 6.7,
          "fiberG": 0.2,
          "range": {
            "kcal": [
              80,
              170
            ],
            "proteinG": [
              5.2,
              8.3
            ],
            "fiberG": [
              0,
              0.4
            ]
          },
          "labelZh": "AI预估，按约70g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 174.5,
          "proteinG": 9.5068,
          "fiberG": 0.296
        },
        "displayValuesPer100g": {
          "kcal": 175,
          "proteinG": 9.5,
          "fiberG": 0.3
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-023.jpg?v=1791937400",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_06c248e6e8548191845a889ea3915dfa",
        "shopifyFileId": "gid://shopify/MediaImage/46505134194930",
        "sourceSha256": "a0e3e4a26555fd34a8d90b687ab6f64ea2eaa3445a4c6c9e4391ccd31aa2c4b6",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-024",
      "cat": "egg",
      "name": "菜脯煎蛋",
      "en": "Preserved Radish Omelette",
      "price": 2,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-023-confirmed-lotus-v1.png?v=1792205566",
      "sourceName": "菜脯煎蛋 Preserved Radish Omelette",
      "sourcePrice": 2,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 193.81,
        "proteinG": 10.1392,
        "fiberG": 0.184,
        "servingGrams": 70,
        "servingGramsRange": [
          60,
          80
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "egg",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "assumed_category_midpoint",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            150,
            235
          ],
          "proteinG": [
            9.8,
            10.3
          ],
          "fiberG": [
            0,
            0.3
          ]
        },
        "assumptionsZh": [
          "菜脯品牌和含糖/脱水程度未知，暂用熟萝卜加糖/酱油代理；纤维和能量不确定性较高。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 70,
          "kcal": 135,
          "proteinG": 7.1,
          "fiberG": 0.1,
          "range": {
            "kcal": [
              90,
              185
            ],
            "proteinG": [
              5.9,
              8.3
            ],
            "fiberG": [
              0,
              0.3
            ]
          },
          "labelZh": "AI预估，按约70g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 193.81,
          "proteinG": 10.1392,
          "fiberG": 0.184
        },
        "displayValuesPer100g": {
          "kcal": 195,
          "proteinG": 10.1,
          "fiberG": 0.2
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-024.jpg?v=1791937416",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_06c248e6e8548191845a889ea3915dfa",
        "shopifyFileId": "gid://shopify/MediaImage/46505134194930",
        "sourceSha256": "a0e3e4a26555fd34a8d90b687ab6f64ea2eaa3445a4c6c9e4391ccd31aa2c4b6",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-025",
      "cat": "egg",
      "name": "番茄炒蛋",
      "en": "Tomato Scrambled Egg",
      "price": 2,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-025-lotus-plate-v2.png?v=1792205277",
      "sourceName": "番茄炒蛋 Tomato Scrambled Egg",
      "sourcePrice": 2,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 148.93,
        "proteinG": 7.0039,
        "fiberG": 0.281,
        "servingGrams": 70,
        "servingGramsRange": [
          60,
          80
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "egg",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "assumed_category_midpoint",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            100,
            205
          ],
          "proteinG": [
            5.6,
            8.5
          ],
          "fiberG": [
            0.1,
            0.4
          ]
        },
        "assumptionsZh": [
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 70,
          "kcal": 105,
          "proteinG": 4.9,
          "fiberG": 0.2,
          "range": {
            "kcal": [
              60,
              165
            ],
            "proteinG": [
              3.3,
              6.8
            ],
            "fiberG": [
              0,
              0.4
            ]
          },
          "labelZh": "AI预估，按约70g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 148.93,
          "proteinG": 7.0039,
          "fiberG": 0.281
        },
        "displayValuesPer100g": {
          "kcal": 150,
          "proteinG": 7,
          "fiberG": 0.3
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-025.jpg?v=1791937432",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_5cdb7bb64b2c81918c6148b7734199d9",
        "shopifyFileId": "gid://shopify/MediaImage/46505122496754",
        "sourceSha256": "fd681a933c0f6e0fea77fabd33c5dc70c22229fc998936825599b0ad9708dde0",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-026",
      "cat": "egg",
      "name": "苦瓜炒蛋",
      "en": "Bitter Gourd with Egg",
      "price": 2,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-026-lotus-plate-v2.png?v=1792205264",
      "sourceName": "苦瓜炒蛋 Bitter Gourd with Egg",
      "sourcePrice": 2,
      "nutrition": {
        "basis": "per_100g",
        "status": "recipe_unconfirmed",
        "labelZh": "配方待核实",
        "kcal": 146.38,
        "proteinG": 7.4036,
        "fiberG": 0.756,
        "servingGrams": 70,
        "servingGramsRange": [
          60,
          80
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "egg",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "assumed_category_midpoint",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            100,
            200
          ],
          "proteinG": [
            5.6,
            8.9
          ],
          "fiberG": [
            0.4,
            1.2
          ]
        },
        "assumptionsZh": [
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 70,
          "kcal": 100,
          "proteinG": 5.2,
          "fiberG": 0.5,
          "range": {
            "kcal": [
              60,
              160
            ],
            "proteinG": [
              3.3,
              7.2
            ],
            "fiberG": [
              0.2,
              0.9
            ]
          },
          "labelZh": "AI预估，按约70g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 146.38,
          "proteinG": 7.4036,
          "fiberG": 0.756
        },
        "displayValuesPer100g": {
          "kcal": 145,
          "proteinG": 7.4,
          "fiberG": 0.8
        },
        "pendingReason": "Actual bitter gourd, egg, oil proportions and cooked serving weight pending; previous 70g AI scenario retained for audit only, excluded from totals.",
        "pendingReasonZh": "苦瓜、鸡蛋、用油比例与熟制份量待核实；旧70g模型仅保留供核查，不计入总量。"
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-026.jpg?v=1791937446",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_b97629b26ed48191808e93990ec1f9dc",
        "shopifyFileId": "gid://shopify/MediaImage/46505121972466",
        "sourceSha256": "b3867c71dab64f5698414034e7e1fa279ab24dfad11ab0b860da1d626648c9e6",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-027",
      "cat": "egg",
      "name": "三色蒸水蛋",
      "en": "Steamed Trio Egg",
      "price": 2,
      "available": true,
      "image": "",
      "sourceName": "三色蒸水蛋 Steamed Trio Egg",
      "sourcePrice": 2,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 100.25,
        "proteinG": 7.2628,
        "fiberG": 0.016,
        "servingGrams": 70,
        "servingGramsRange": [
          60,
          80
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "egg",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "assumed_category_midpoint",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            60,
            155
          ],
          "proteinG": [
            5.1,
            9.9
          ],
          "fiberG": [
            0,
            0.1
          ]
        },
        "assumptionsZh": [
          "暂按鸡蛋、咸蛋、皮蛋三种；加水比例约20–60%。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "cfs_food_search",
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 70,
          "kcal": 70,
          "proteinG": 5.1,
          "fiberG": 0,
          "range": {
            "kcal": [
              35,
              125
            ],
            "proteinG": [
              3,
              7.9
            ],
            "fiberG": [
              0,
              0.1
            ]
          },
          "labelZh": "AI预估，按约70g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 100.25,
          "proteinG": 7.2628,
          "fiberG": 0.016
        },
        "displayValuesPer100g": {
          "kcal": 100,
          "proteinG": 7.3,
          "fiberG": 0
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "ownerRecipeFacts": {
        "ingredientsEn": [
          "chicken egg",
          "salted egg",
          "century egg"
        ],
        "contains": [
          "egg"
        ],
        "sourceMessageId": "Sentinel_4420fa6c3b9c81918c0d88aa66cde6cd",
        "status": "owner_confirmed",
        "notCompleteIngredientList": true
      },
      "withdrawnImage": {
        "url": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-epos-027-lotus-reference.png?v=1792226229",
        "sourceMessageId": "Sentinel_09b935a3db808191822c5925cc542d4d",
        "reason": "Owner requested removing this food photo; retain dish and text until replacement approved."
      }
    },
    {
      "id": "epos-028",
      "cat": "egg",
      "name": "煎酿三宝",
      "en": "Pan-Fried Yong Tau Foo",
      "price": 2,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-028-original-plate-v1.png?v=1792205292",
      "sourceName": "煎酿三宝 (1pc) Pan-Fried Yong Tau Foo",
      "sourcePrice": 2,
      "portionEn": "1 piece",
      "portionZh": "1 件",
      "nutrition": {
        "basis": "per_100g",
        "status": "pending",
        "labelZh": "待补配方",
        "kcal": null,
        "proteinG": null,
        "fiberG": null,
        "servingGrams": null,
        "servingGramsRange": [
          80,
          80
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "dish",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "edible_weight_unconfirmed",
        "source": null,
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "unknown",
        "rangePer100g": null,
        "assumptionsZh": [
          "请提供1件的食材/馅料（鱼糜或肉等）、每件熟重及煎炸方式。"
        ],
        "sourceIds": [],
        "perServingEstimate": null
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-028.jpg?v=1791937456",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_78123c12bcb48191beb7498a8214a846",
        "shopifyFileId": "gid://shopify/MediaImage/46505122988274",
        "sourceSha256": "3119603f698361260b0a036dfaeb57f21cd9d61143a0a0b82449a8e52383e270",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-029",
      "cat": "egg",
      "name": "肉末蒸蛋",
      "en": "Steamed Minced Pork Egg",
      "price": 3,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-029-confirmed-lotus-v1.png?v=1792205526",
      "sourceName": "肉末蒸蛋 Steamed Minced Pork Egg",
      "sourcePrice": 3,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 116.98,
        "proteinG": 9.1392,
        "fiberG": 0.024,
        "servingGrams": 70,
        "servingGramsRange": [
          60,
          80
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "egg",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "assumed_category_midpoint",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            70,
            185
          ],
          "proteinG": [
            5.9,
            13.1
          ],
          "fiberG": [
            0,
            0.1
          ]
        },
        "assumptionsZh": [
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 70,
          "kcal": 80,
          "proteinG": 6.4,
          "fiberG": 0,
          "range": {
            "kcal": [
              40,
              145
            ],
            "proteinG": [
              3.5,
              10.5
            ],
            "fiberG": [
              0,
              0.1
            ]
          },
          "labelZh": "AI预估，按约70g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 116.98,
          "proteinG": 9.1392,
          "fiberG": 0.024
        },
        "displayValuesPer100g": {
          "kcal": 115,
          "proteinG": 9.1,
          "fiberG": 0
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-029.jpg?v=1791937468",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_ecb9a58d760c81919dda4e36ef3a042a",
        "shopifyFileId": "gid://shopify/MediaImage/46505132425458",
        "sourceSha256": "7195708cf9bd272ee2fc63545555e0a5c1f3f0834891d1000f948fa0160f8139",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-030",
      "cat": "egg",
      "name": "招牌炸豆腐",
      "en": "Signature Crispy Tofu",
      "price": 2,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-030-white-ceramic-v2.png?v=1792205086",
      "sourceName": "招牌炸豆腐 (1pc) Signature Crispy Tofu",
      "sourcePrice": 2,
      "portionEn": "1 piece",
      "portionZh": "1 件",
      "nutrition": {
        "basis": "per_100g",
        "status": "pending",
        "labelZh": "待补配方",
        "kcal": null,
        "proteinG": null,
        "fiberG": null,
        "servingGrams": 50,
        "servingGramsRange": null,
        "servingRangeBasis": "Owner-specific override: 005 and 011 total dish with broth 120–150 g, midpoint 135 g; 030 approximately 50 g per piece, not a measured exact weight",
        "servingAssumptionCategory": "special_approx_piece",
        "servingInstructionMessageId": "Sentinel_d27e68f8e2b481919262aad0dd7ac41d",
        "servingWeightStatus": "owner_approx_piece_weight_recipe_pending",
        "source": null,
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "unknown",
        "rangePer100g": null,
        "assumptionsZh": [
          "用户已给每件约50g；仍需确认黄豆豆腐、蛋豆腐或自制豆腐饼，有无裹粉/其他馅料及煎炸方式，重量本身不足以确定营养。"
        ],
        "sourceIds": [],
        "perServingEstimate": null
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-030.jpg?v=1791937479",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_bd559d6487108191a057c1cb0ba0e004",
        "shopifyFileId": "gid://shopify/MediaImage/46505111912690",
        "sourceSha256": "44d57e2600391d4df2d5fb1d0b40802a516e17b8d5182aeb578faa729d121415",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-031",
      "cat": "egg",
      "name": "麻婆豆腐",
      "en": "Mapo Tofu",
      "price": 2,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-031-lotus-plate-v2.png?v=1792205330",
      "sourceName": "麻婆豆腐 Mapo Tofu",
      "sourcePrice": 2,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 148.93,
        "proteinG": 8.8824,
        "fiberG": 0.424,
        "servingGrams": 80,
        "servingGramsRange": [
          80,
          80
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "dish",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "owner_requested_assumed_80g",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            100,
            215
          ],
          "proteinG": [
            7.8,
            10.1
          ],
          "fiberG": [
            0.3,
            0.5
          ]
        },
        "assumptionsZh": [
          "假设含猪肉末；豆瓣酱暂用味噌作为发酵豆酱代理，不能据此判断过敏原。",
          "豆腐为主，不按蛋类70g；暂采用用户普通菜每份80g作为份量假设，并非蔬菜配方或实测。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 80,
          "kcal": 120,
          "proteinG": 7.1,
          "fiberG": 0.3,
          "range": {
            "kcal": [
              80,
              175
            ],
            "proteinG": [
              6.2,
              8.1
            ],
            "fiberG": [
              0.2,
              0.4
            ]
          },
          "labelZh": "AI预估，按约80g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 148.93,
          "proteinG": 8.8824,
          "fiberG": 0.424
        },
        "displayValuesPer100g": {
          "kcal": 150,
          "proteinG": 8.9,
          "fiberG": 0.4
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 2,
        "sourceMessageId": "Sentinel_f64d726a5030819189e91810d7d672a5",
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-031.jpg?v=1791937489",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_c97f32b7f5dc8191bd9184d449c1f8ae",
        "shopifyFileId": "gid://shopify/MediaImage/46505124298994",
        "sourceSha256": "fd55483b982f4948b8ed8c37463579e09d4e0272fc7ddb73c8f707b3f54f8773",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-032",
      "cat": "meat",
      "name": "清蒸金目鲈",
      "en": "Steamed Seabass Fish",
      "price": 4,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-032-white-ceramic-v2.png?v=1792205043",
      "sourceName": "清蒸金目鲈 Steamed Seabass Fish",
      "sourcePrice": 4,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 140.8,
        "proteinG": 21.1848,
        "fiberG": 0.144,
        "servingGrams": 110,
        "servingGramsRange": [
          100,
          120
        ],
        "servingRangeBasis": "Owner-authorised approximate portions interpreted as cooked edible dish mass for this model only; NOT measured weight; no inferred bone-removal yield.",
        "servingAssumptionCategory": "meat",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "assumed_cooked_edible_weight_unconfirmed",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            115,
            180
          ],
          "proteinG": [
            19,
            21.6
          ],
          "fiberG": [
            0.1,
            0.3
          ]
        },
        "assumptionsZh": [
          "海鲈通用种类代理金目鲈；仅计无骨可食鱼肉与吃下的汁。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。",
          "AI预估：暂按110g熟制可食成菜（不含骨壳）计算，非实际称重；如所报份量含骨壳，营养估算需调整。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 110,
          "kcal": 155,
          "proteinG": 23.3,
          "fiberG": 0.2,
          "range": {
            "kcal": [
              115,
              216
            ],
            "proteinG": [
              19,
              25.9
            ],
            "fiberG": [
              0.1,
              0.4
            ]
          },
          "labelZh": "AI预估：暂按110g熟制可食成菜（不含骨壳）计算，非实际称重；如所报份量含骨壳，营养估算需调整。"
        },
        "calculationValuesPer100g": {
          "kcal": 140.8,
          "proteinG": 21.1848,
          "fiberG": 0.144
        },
        "displayValuesPer100g": {
          "kcal": 140,
          "proteinG": 21.2,
          "fiberG": 0.1
        },
        "servingDisclaimerEn": "AI estimate using 110g cooked edible portion (excluding bones/shells); actual serving may differ.",
        "servingDisclaimerZh": "AI预估：暂按110g熟制可食成菜（不含骨壳）计算，非实际称重；如所报份量含骨壳，营养估算需调整。"
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "sourceMessageId": "Sentinel_f64d726a5030819189e91810d7d672a5",
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-032.jpg?v=1791937500",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_0eee8ab06128819191e05370f99501b5",
        "shopifyFileId": "gid://shopify/MediaImage/46505107783922",
        "sourceSha256": "868519b6a8e55ef752299908f2043dd137a09a1279360e84a1a1b75d0374755b",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-033",
      "cat": "meat",
      "name": "回锅肉",
      "en": "Twice Cooked Pork",
      "price": 3,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-033-lotus-plate-v2.png?v=1792205305",
      "sourceName": "回锅肉 Twice Cooked Pork",
      "sourcePrice": 3,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 358.935,
        "proteinG": 15.3081,
        "fiberG": 0.632,
        "servingGrams": 110,
        "servingGramsRange": [
          100,
          120
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "meat",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "assumed_category_midpoint",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            240,
            475
          ],
          "proteinG": [
            13.9,
            15.4
          ],
          "fiberG": [
            0.3,
            0.9
          ]
        },
        "assumptionsZh": [
          "五花肉肥瘦比未核实；配菜按包菜近似。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_fndds_2024",
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 110,
          "kcal": 395,
          "proteinG": 16.8,
          "fiberG": 0.7,
          "range": {
            "kcal": [
              240,
              570
            ],
            "proteinG": [
              13.9,
              18.4
            ],
            "fiberG": [
              0.3,
              1.1
            ]
          },
          "labelZh": "AI预估，按约110g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 358.935,
          "proteinG": 15.3081,
          "fiberG": 0.632
        },
        "displayValuesPer100g": {
          "kcal": 360,
          "proteinG": 15.3,
          "fiberG": 0.6
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 2,
        "sourceMessageId": "Sentinel_f64d726a5030819189e91810d7d672a5",
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-033.jpg?v=1791937513",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_8c9e2752e2f08191b12a79367c172b94",
        "shopifyFileId": "gid://shopify/MediaImage/46505123512562",
        "sourceSha256": "8d9abc5c9ba83fce94f3710e1c852f6b1c02ac6fb5d823850ef6daf359b3fdf5",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-034",
      "cat": "meat",
      "name": "当归荷叶蒸鸡",
      "en": "Dang Gui Lotus Leaf Steamed Chicken",
      "price": 3,
      "available": true,
      "sourceName": "荷叶蒸鸡 Lotus Leaf Steam Chicken",
      "sourcePrice": 3,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 220.87,
        "proteinG": 20.1636,
        "fiberG": 0.169,
        "servingGrams": 110,
        "servingGramsRange": [
          100,
          120
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "meat",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "assumed_cooked_edible_weight_unconfirmed",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            150,
            250
          ],
          "proteinG": [
            19.1,
            21.4
          ],
          "fiberG": [
            0,
            0.3
          ]
        },
        "assumptionsZh": [
          "荷叶不计入可食部分；假设含皮鸡肉，骨重不得算成净肉。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。",
          "AI预估：暂按110g熟制可食成菜（包括吃下的汁，不含骨）计算，未实秤；配方和用油仍是假设。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 110,
          "kcal": 245,
          "proteinG": 22.2,
          "fiberG": 0.2,
          "range": {
            "kcal": [
              150,
              300
            ],
            "proteinG": [
              19.1,
              25.7
            ],
            "fiberG": [
              0,
              0.4
            ]
          },
          "labelZh": "AI预估：暂按110g熟制可食成菜（包括吃下的汁，不含骨）计算，未实秤；配方和用油仍是假设。"
        },
        "calculationValuesPer100g": {
          "kcal": 220.87,
          "proteinG": 20.1636,
          "fiberG": 0.169
        },
        "displayValuesPer100g": {
          "kcal": 220,
          "proteinG": 20.2,
          "fiberG": 0.2
        },
        "servingDisclaimerEn": "AI estimate using 110g cooked edible portion (excluding bones); actual serving and recipe may differ."
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "previousImageReview": {
        "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-epos-034-lotus-reference.png?v=1792225928",
        "status": "superseded-awaiting-reference-revision",
        "sourceMessageId": "Sentinel_3492832fa76881919efbb407010e938b"
      },
      "ownerRecipeFacts": {
        "ingredientsEn": [
          "chicken",
          "dang gui",
          "lotus leaf"
        ],
        "status": "owner_confirmed",
        "notCompleteIngredientList": true,
        "sourceMessageId": "Sentinel_3492832fa76881919efbb407010e938b"
      },
      "withdrawnImage": {
        "url": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-epos-034-angelica-lotus-leaf-chicken-owner-reference-v2.png?v=1792226648",
        "sourceMessageId": "Sentinel_fc3e8d8362348191a6a77567285507b6",
        "reason": "Owner rejected resemblance and appetite appeal; do not restore."
      },
      "image": ""
    },
    {
      "id": "epos-035",
      "cat": "meat",
      "name": "咕噜肉",
      "en": "Sweet & Sour Pork",
      "price": 3,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-035-lotus-plate-v2.png?v=1792205318",
      "sourceName": "咕噜肉 Sweet & Sour Pork",
      "sourcePrice": 3,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 243.14,
        "proteinG": 13.374,
        "fiberG": 0.312,
        "servingGrams": 110,
        "servingGramsRange": [
          100,
          120
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "meat",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "assumed_category_midpoint",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            180,
            385
          ],
          "proteinG": [
            13,
            15.5
          ],
          "fiberG": [
            0.2,
            0.4
          ]
        },
        "assumptionsZh": [
          "炸粉和吸油、糖汁均为情景假设。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 110,
          "kcal": 265,
          "proteinG": 14.7,
          "fiberG": 0.3,
          "range": {
            "kcal": [
              180,
              460
            ],
            "proteinG": [
              13,
              18.6
            ],
            "fiberG": [
              0.2,
              0.5
            ]
          },
          "labelZh": "AI预估，按约110g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 243.14,
          "proteinG": 13.374,
          "fiberG": 0.312
        },
        "displayValuesPer100g": {
          "kcal": 245,
          "proteinG": 13.4,
          "fiberG": 0.3
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "sourceMessageId": "Sentinel_f64d726a5030819189e91810d7d672a5",
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-035.jpg?v=1791937525",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_0a2c9aac0e3c8191ad77b0d144450f9f",
        "shopifyFileId": "gid://shopify/MediaImage/46505124036850",
        "sourceSha256": "787eff77ffecb85e9aaa3d7f2033ca3c0a536f0710beaae43487fdbf1ba9c491",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-036",
      "cat": "meat",
      "name": "青椒炒肉丝",
      "en": "Pork w/ Green Pepper",
      "price": 3,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-036-original-plate-v1.png?v=1792205348",
      "sourceName": "青椒炒肉丝 Pork w/ Green Pepper",
      "sourcePrice": 3,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 157.17,
        "proteinG": 17.4338,
        "fiberG": 0.351,
        "servingGrams": 110,
        "servingGramsRange": [
          100,
          120
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "meat",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "assumed_category_midpoint",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            115,
            315
          ],
          "proteinG": [
            13.6,
            19.7
          ],
          "fiberG": [
            0.1,
            0.6
          ]
        },
        "assumptionsZh": [
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 110,
          "kcal": 175,
          "proteinG": 19.2,
          "fiberG": 0.4,
          "range": {
            "kcal": [
              115,
              375
            ],
            "proteinG": [
              13.6,
              23.7
            ],
            "fiberG": [
              0.1,
              0.7
            ]
          },
          "labelZh": "AI预估，按约110g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 157.17,
          "proteinG": 17.4338,
          "fiberG": 0.351
        },
        "displayValuesPer100g": {
          "kcal": 155,
          "proteinG": 17.4,
          "fiberG": 0.4
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 2,
        "sourceMessageId": "Sentinel_f64d726a5030819189e91810d7d672a5",
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-036.jpg?v=1791937536",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_40e1cc62453c8191a16b039443cf73a0",
        "shopifyFileId": "gid://shopify/MediaImage/46505125118194",
        "sourceSha256": "785d6dffda6e96cebd5e03bf470dd940772fa4f25cd147d7dba4dd18888ca68c",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-037",
      "cat": "meat",
      "name": "南乳脆皮五花肉",
      "en": "Crispy Pork Belly",
      "price": 3,
      "available": true,
      "image": "",
      "sourceName": "南乳脆皮五花肉 (5pcs) Crispy Pork Belly",
      "sourcePrice": 3,
      "portionEn": "5 pieces",
      "portionZh": "5 件",
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 469.015,
        "proteinG": 19.2864,
        "fiberG": 0.198,
        "servingGrams": null,
        "servingGramsRange": [
          100,
          120
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "meat",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "edible_weight_unconfirmed",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            400,
            535
          ],
          "proteinG": [
            14.4,
            24.4
          ],
          "fiberG": [
            0.1,
            0.2
          ]
        },
        "assumptionsZh": [
          "南乳用发酵豆酱代理；保留原5件规格，未称净熟重；皮/肥肉/吸油差异大。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。",
          "售卖规格保留5 件；未将件数/棵数换成已知克数。"
        ],
        "sourceIds": [
          "usda_fndds_2024",
          "usda_sr_2018"
        ],
        "perServingEstimate": null,
        "calculationValuesPer100g": {
          "kcal": 469.015,
          "proteinG": 19.2864,
          "fiberG": 0.198
        },
        "displayValuesPer100g": {
          "kcal": 470,
          "proteinG": 19.3,
          "fiberG": 0.2
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "withdrawnImage": {
        "url": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-epos-037-lotus-reference.png?v=1792225940",
        "sourceMessageId": "Sentinel_09b935a3db808191822c5925cc542d4d",
        "reason": "Owner requested removing this food photo; retain dish and text until replacement approved."
      }
    },
    {
      "id": "epos-038",
      "cat": "meat",
      "name": "鱼香肉丝",
      "en": "Fish-Fragrant Shredded Pork",
      "price": 3,
      "available": true,
      "image": "",
      "sourceName": "鱼香肉丝 Fish-Fragrant Shredded Pork",
      "sourcePrice": 3,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 161.5,
        "proteinG": 14.8355,
        "fiberG": 1.115,
        "servingGrams": 110,
        "servingGramsRange": [
          100,
          120
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "meat",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "assumed_category_midpoint",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            115,
            310
          ],
          "proteinG": [
            12.3,
            17.1
          ],
          "fiberG": [
            0.7,
            1.5
          ]
        },
        "assumptionsZh": [
          "鱼香口味不代表含鱼；竹笋/木耳/胡萝卜为假设配菜，非过敏原结论。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 110,
          "kcal": 180,
          "proteinG": 16.3,
          "fiberG": 1.2,
          "range": {
            "kcal": [
              115,
              375
            ],
            "proteinG": [
              12.3,
              20.5
            ],
            "fiberG": [
              0.7,
              1.8
            ]
          },
          "labelZh": "AI预估，按约110g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 161.5,
          "proteinG": 14.8355,
          "fiberG": 1.115
        },
        "displayValuesPer100g": {
          "kcal": 160,
          "proteinG": 14.8,
          "fiberG": 1.1
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "ownerRecipeFacts": {
        "ingredientsEn": [
          "pork",
          "bamboo shoots",
          "wood-ear mushrooms",
          "carrot"
        ],
        "sourceMessageId": "Sentinel_4420fa6c3b9c81918c0d88aa66cde6cd",
        "status": "owner_confirmed",
        "notCompleteIngredientList": true
      },
      "withdrawnImage": {
        "url": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-fish-fragrant-shredded-pork-lotus-reference.png?v=1792225735",
        "sourceMessageId": "Sentinel_09b935a3db808191822c5925cc542d4d",
        "reason": "Owner requested removing this food photo; retain dish and text until replacement approved."
      }
    },
    {
      "id": "epos-039",
      "cat": "meat",
      "name": "辣子鸡",
      "en": "Spicy Diced Chicken",
      "price": 3,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-039-chilli-chicken-landscape-v1.png?v=1792205189",
      "sourceName": "辣子鸡 Spicy Diced Chicken",
      "sourcePrice": 3,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 241.84,
        "proteinG": 18.5174,
        "fiberG": 0.227,
        "servingGrams": 110,
        "servingGramsRange": [
          100,
          120
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "meat",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "assumed_cooked_edible_weight_unconfirmed",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            205,
            315
          ],
          "proteinG": [
            16.1,
            20.1
          ],
          "fiberG": [
            0.2,
            0.3
          ]
        },
        "assumptionsZh": [
          "鸡肉基底采用未油炸熟鸡肉，另外计入总保留油，避免重复计算炸油。骨与通常不吃下的干辣椒不应计入可食重量；油量范围较宽。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。",
          "AI预估：暂按110g熟制可食成菜（包括吃下的汁，不含骨）计算，未实秤；配方和用油仍是假设。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 110,
          "kcal": 265,
          "proteinG": 20.4,
          "fiberG": 0.2,
          "range": {
            "kcal": [
              205,
              378
            ],
            "proteinG": [
              16.1,
              24.1
            ],
            "fiberG": [
              0.2,
              0.4
            ]
          },
          "labelZh": "AI预估：暂按110g熟制可食成菜（包括吃下的汁，不含骨）计算，未实秤；配方和用油仍是假设。"
        },
        "calculationValuesPer100g": {
          "kcal": 241.84,
          "proteinG": 18.5174,
          "fiberG": 0.227
        },
        "displayValuesPer100g": {
          "kcal": 240,
          "proteinG": 18.5,
          "fiberG": 0.2
        },
        "servingDisclaimerEn": "AI estimate using 110g cooked edible portion (excluding bones); actual serving and recipe may differ."
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 1,
        "sourceMessageId": "Sentinel_f64d726a5030819189e91810d7d672a5",
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-039.jpg?v=1791937547",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_c03a0b8b8f7c81918b1ee8243f4f5d71",
        "shopifyFileId": "gid://shopify/MediaImage/46505118138610",
        "sourceSha256": "40a7bb94ac13a7116428c11f40d0446ffb3988031d4cc66060c4eb286faf162c",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-040",
      "cat": "meat",
      "name": "虫草菌菇蒸土鸡",
      "en": "Steamed Free-Range Chicken with Cordyceps & Mushrooms",
      "price": 3,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-040-white-ceramic-v2.png?v=1792205074",
      "sourceName": "虫草菌菇蒸土鸡 Steamed Free-Range Chicken with Cordyceps & Mushroom Rice",
      "sourcePrice": 3,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 203.27,
        "proteinG": 17.9896,
        "fiberG": 0.379,
        "servingGrams": 110,
        "servingGramsRange": [
          100,
          120
        ],
        "servingRangeBasis": "Owner-authorised approximate portions interpreted as cooked edible dish mass for this model only; NOT measured weight; no inferred bone-removal yield.",
        "servingAssumptionCategory": "meat",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "assumed_cooked_edible_weight_unconfirmed",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            140,
            235
          ],
          "proteinG": [
            16.8,
            20.7
          ],
          "fiberG": [
            0.1,
            0.6
          ]
        },
        "assumptionsZh": [
          "全部菌菇暂按熟香菇代理，未加入所谓药用营养/功效；带骨须扣骨。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。",
          "AI预估：暂按110g熟制可食成菜（不含骨壳）计算，非实际称重；如所报份量含骨壳，营养估算需调整。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 110,
          "kcal": 225,
          "proteinG": 19.8,
          "fiberG": 0.4,
          "range": {
            "kcal": [
              140,
              282
            ],
            "proteinG": [
              16.8,
              24.8
            ],
            "fiberG": [
              0.1,
              0.7
            ]
          },
          "labelZh": "AI预估：暂按110g熟制可食成菜（不含骨壳）计算，非实际称重；如所报份量含骨壳，营养估算需调整。"
        },
        "calculationValuesPer100g": {
          "kcal": 203.27,
          "proteinG": 17.9896,
          "fiberG": 0.379
        },
        "displayValuesPer100g": {
          "kcal": 205,
          "proteinG": 18,
          "fiberG": 0.4
        },
        "servingDisclaimerEn": "AI estimate using 110g cooked edible portion (excluding bones/shells); actual serving may differ.",
        "servingDisclaimerZh": "AI预估：暂按110g熟制可食成菜（不含骨壳）计算，非实际称重；如所报份量含骨壳，营养估算需调整。"
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "sourceMessageId": "Sentinel_f64d726a5030819189e91810d7d672a5",
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-040.jpg?v=1791937559",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_fdd116c31d208191b63393c942c6796e",
        "shopifyFileId": "gid://shopify/MediaImage/46505111355634",
        "sourceSha256": "181f223069a9337d78d268be90faec376d603ca84628268fac9604fcc130ff5f",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-041",
      "cat": "meat",
      "name": "白萝卜炖牛腩",
      "en": "Braised Beef Brisket with Radish",
      "price": 4,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-041-lotus-plate-v2.png?v=1792205377",
      "sourceName": "白萝卜炖牛腩 Braised Beef Brisket with Radish",
      "sourcePrice": 4,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 246.94,
        "proteinG": 17.2631,
        "fiberG": 0.432,
        "servingGrams": 110,
        "servingGramsRange": [
          100,
          120
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "meat",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "assumed_category_midpoint",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            130,
            305
          ],
          "proteinG": [
            16.6,
            21.1
          ],
          "fiberG": [
            0.1,
            0.7
          ]
        },
        "assumptionsZh": [
          "牛腩肥瘦与萝卜/汤汁比例不同会改变估值。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 110,
          "kcal": 270,
          "proteinG": 19,
          "fiberG": 0.5,
          "range": {
            "kcal": [
              130,
              365
            ],
            "proteinG": [
              16.6,
              25.3
            ],
            "fiberG": [
              0.1,
              0.8
            ]
          },
          "labelZh": "AI预估，按约110g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 246.94,
          "proteinG": 17.2631,
          "fiberG": 0.432
        },
        "displayValuesPer100g": {
          "kcal": 245,
          "proteinG": 17.3,
          "fiberG": 0.4
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "sourceMessageId": "Sentinel_f64d726a5030819189e91810d7d672a5",
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-041.jpg?v=1791937570",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_eb0faadd598081918db897c80843e1e8",
        "shopifyFileId": "gid://shopify/MediaImage/46505127215346",
        "sourceSha256": "bd6df3cb0ce282b552165603c48d31a34bd92523454d3fb4c93524a7f50968f8",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-042",
      "cat": "meat",
      "name": "番茄虾",
      "en": "Tomato Tiger Prawns",
      "price": 3,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-042-lotus-plate-v1.png?v=1792205391",
      "sourceName": "番茄虾 (2pcs) Tomato Tiger Prawns",
      "sourcePrice": 3,
      "portionEn": "2 pieces",
      "portionZh": "2 件",
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 151.03,
        "proteinG": 16.299,
        "fiberG": 0.16,
        "servingGrams": null,
        "servingGramsRange": [
          100,
          120
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "meat",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "edible_weight_unconfirmed",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            105,
            190
          ],
          "proteinG": [
            14.1,
            18.1
          ],
          "fiberG": [
            0,
            0.3
          ]
        },
        "assumptionsZh": [
          "原规格2件虾，虾头虾壳不计营养；未称净肉，不自动将2件当110g可食部。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。",
          "售卖规格保留2 件；未将件数/棵数换成已知克数。",
          "带骨/带壳可能性：店家100–120g尚未确认是否含骨壳；每份营养暂不计算。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": null,
        "calculationValuesPer100g": {
          "kcal": 151.03,
          "proteinG": 16.299,
          "fiberG": 0.16
        },
        "displayValuesPer100g": {
          "kcal": 150,
          "proteinG": 16.3,
          "fiberG": 0.2
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-042.jpg?v=1791937582",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_256d57ba04f0819189c83eabe32e057f",
        "shopifyFileId": "gid://shopify/MediaImage/46505127706866",
        "sourceSha256": "5c8163b961a9f002383a246f0cb03500a00bb7f6aad6a65b84d1b1db33136120",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-043",
      "cat": "meat",
      "name": "咸鱼蒸肉饼",
      "en": "Steamed Pork Patty With Salted Fish",
      "price": 3.5,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-043-lotus-plate-v1.png?v=1792205403",
      "sourceName": "咸鱼蒸肉饼 Steamed Pork Patty With Salted Fish",
      "sourcePrice": 3.5,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 251.87,
        "proteinG": 22.7034,
        "fiberG": 0.091,
        "servingGrams": 110,
        "servingGramsRange": [
          100,
          120
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "meat",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "assumed_category_midpoint",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            115,
            315
          ],
          "proteinG": [
            19,
            25.2
          ],
          "fiberG": [
            0,
            0.1
          ]
        },
        "assumptionsZh": [
          "肉饼肥瘦比例未知；咸鱼用干盐鳕代理。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 110,
          "kcal": 275,
          "proteinG": 25,
          "fiberG": 0.1,
          "range": {
            "kcal": [
              115,
              380
            ],
            "proteinG": [
              19,
              30.2
            ],
            "fiberG": [
              0,
              0.2
            ]
          },
          "labelZh": "AI预估，按约110g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 251.87,
          "proteinG": 22.7034,
          "fiberG": 0.091
        },
        "displayValuesPer100g": {
          "kcal": 250,
          "proteinG": 22.7,
          "fiberG": 0.1
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "sourceMessageId": "Sentinel_f64d726a5030819189e91810d7d672a5",
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-043.jpg?v=1791937597",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_bb38196e16f081919f322b14c2e11736",
        "shopifyFileId": "gid://shopify/MediaImage/46505128034546",
        "sourceSha256": "1e6165942bd8ead892a3978bc11976c7e2162f93097f52ca90c973a4c71bdfd2",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-044",
      "cat": "meat",
      "name": "梅菜扣肉",
      "en": "Pork Belly w/ Mui Choy",
      "price": 3,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-044-lotus-plate-v1.png?v=1792205417",
      "sourceName": "梅菜扣肉 (2pcs) Pork Belly w/ Mui Choy",
      "sourcePrice": 3,
      "portionEn": "2 pieces",
      "portionZh": "2 件",
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 348.525,
        "proteinG": 15.0337,
        "fiberG": 0.44,
        "servingGrams": null,
        "servingGramsRange": [
          100,
          120
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "meat",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "edible_weight_unconfirmed",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            225,
            460
          ],
          "proteinG": [
            13.9,
            15.1
          ],
          "fiberG": [
            0.1,
            0.7
          ]
        },
        "assumptionsZh": [
          "梅菜以熟芥菜代理其固体部分，另加油糖；保留2件规格，未称重。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。",
          "售卖规格保留2 件；未将件数/棵数换成已知克数。"
        ],
        "sourceIds": [
          "usda_fndds_2024",
          "usda_sr_2018"
        ],
        "perServingEstimate": null,
        "calculationValuesPer100g": {
          "kcal": 348.525,
          "proteinG": 15.0337,
          "fiberG": 0.44
        },
        "displayValuesPer100g": {
          "kcal": 350,
          "proteinG": 15,
          "fiberG": 0.4
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-044.jpg?v=1791937607",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_1b15588c79608191a8fb8be9b5160494",
        "shopifyFileId": "gid://shopify/MediaImage/46505128362226",
        "sourceSha256": "402e04af0e7e39c12051836b683ff35afe0c70d52c5c6d09f43f05756cd06fa7",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-045",
      "cat": "meat",
      "name": "亚参魔鬼鱼",
      "en": "Asam Stingray",
      "price": 3,
      "available": true,
      "sourceName": "亚参魔鬼鱼 Asam Stingray",
      "sourcePrice": 3,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 137.25,
        "proteinG": 16.906,
        "fiberG": 0.345,
        "servingGrams": 110,
        "servingGramsRange": [
          100,
          120
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "meat",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "assumed_cooked_edible_weight_unconfirmed",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            100,
            180
          ],
          "proteinG": [
            16.4,
            18.3
          ],
          "fiberG": [
            0.2,
            0.4
          ]
        },
        "assumptionsZh": [
          "鱼种与熟制出品率为代理；软骨/骨头须扣除，不含未确认椰浆。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。",
          "AI预估：暂按110g熟制可食成菜（包括吃下的汁，不含骨）计算，未实秤；配方和用油仍是假设。"
        ],
        "sourceIds": [
          "cfs_food_search",
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 110,
          "kcal": 150,
          "proteinG": 18.6,
          "fiberG": 0.4,
          "range": {
            "kcal": [
              100,
              216
            ],
            "proteinG": [
              16.4,
              22
            ],
            "fiberG": [
              0.2,
              0.5
            ]
          },
          "labelZh": "AI预估：暂按110g熟制可食成菜（包括吃下的汁，不含骨）计算，未实秤；配方和用油仍是假设。"
        },
        "calculationValuesPer100g": {
          "kcal": 137.25,
          "proteinG": 16.906,
          "fiberG": 0.345
        },
        "displayValuesPer100g": {
          "kcal": 135,
          "proteinG": 16.9,
          "fiberG": 0.3
        },
        "servingDisclaimerEn": "AI estimate using 110g cooked edible portion (excluding bones); actual serving and recipe may differ."
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 2,
        "sourceMessageId": "Sentinel_f64d726a5030819189e91810d7d672a5",
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "withdrawnImage": {
        "url": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-epos-045-asam-stingray-lotus-reference.png?v=1792226600",
        "sourceMessageId": "Sentinel_fc3e8d8362348191a6a77567285507b6",
        "reason": "Owner rejected resemblance and appetite appeal; do not restore."
      },
      "image": ""
    },
    {
      "id": "epos-046",
      "cat": "meat",
      "name": "台湾卤肉",
      "en": "Taiwanese Braised Pork",
      "price": 3,
      "available": true,
      "sourceName": "台湾卤肉 Taiwanese Braised Pork",
      "sourcePrice": 3,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 365.91,
        "proteinG": 15.3906,
        "fiberG": 0.188,
        "servingGrams": 110,
        "servingGramsRange": [
          100,
          120
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "meat",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "assumed_category_midpoint",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            190,
            475
          ],
          "proteinG": [
            13.9,
            15.4
          ],
          "fiberG": [
            0,
            0.3
          ]
        },
        "assumptionsZh": [
          "暂按五花肉卤肉情景；若用纯瘦肉或不同肥瘦肉末须更新。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_fndds_2024",
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 110,
          "kcal": 405,
          "proteinG": 16.9,
          "fiberG": 0.2,
          "range": {
            "kcal": [
              190,
              565
            ],
            "proteinG": [
              13.9,
              18.5
            ],
            "fiberG": [
              0,
              0.4
            ]
          },
          "labelZh": "AI预估，按约110g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 365.91,
          "proteinG": 15.3906,
          "fiberG": 0.188
        },
        "displayValuesPer100g": {
          "kcal": 365,
          "proteinG": 15.4,
          "fiberG": 0.2
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "ownerRecipeFacts": {
        "ingredientsEn": [
          "lean-heavy pork in small chunks",
          "quail eggs"
        ],
        "contains": [
          "egg"
        ],
        "sourceMessageId": "Sentinel_4420fa6c3b9c81918c0d88aa66cde6cd",
        "status": "owner_confirmed",
        "notCompleteIngredientList": true
      },
      "previousImageReview": {
        "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-epos-046-lotus-reference.png?v=1792226241",
        "status": "superseded-awaiting-owner-photo",
        "sourceMessageId": "Sentinel_3492832fa76881919efbb407010e938b"
      }
    },
    {
      "id": "epos-047",
      "cat": "meat",
      "name": "宫保鱿鱼",
      "en": "Kung Pao Squid",
      "price": 3,
      "available": true,
      "image": "",
      "sourceName": "宫保鱿鱼 Kung Pao Squid",
      "sourcePrice": 3,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 198.79,
        "proteinG": 14.9864,
        "fiberG": 0.86,
        "servingGrams": 110,
        "servingGramsRange": [
          100,
          120
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "meat",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "assumed_category_midpoint",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            145,
            270
          ],
          "proteinG": [
            14.5,
            15.4
          ],
          "fiberG": [
            0.5,
            1.2
          ]
        },
        "assumptionsZh": [
          "宫保暂按含花生情景，仅作营养模型，不是已核实过敏原信息。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 110,
          "kcal": 220,
          "proteinG": 16.5,
          "fiberG": 0.9,
          "range": {
            "kcal": [
              145,
              325
            ],
            "proteinG": [
              14.5,
              18.4
            ],
            "fiberG": [
              0.5,
              1.4
            ]
          },
          "labelZh": "AI预估，按约110g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 198.79,
          "proteinG": 14.9864,
          "fiberG": 0.86
        },
        "displayValuesPer100g": {
          "kcal": 200,
          "proteinG": 15,
          "fiberG": 0.9
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 1,
        "sourceMessageId": "Sentinel_f64d726a5030819189e91810d7d672a5",
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "ownerRecipeFacts": {
        "recipeExcludes": [
          "peanuts"
        ],
        "crossContactVerified": false,
        "sourceMessageId": "Sentinel_4420fa6c3b9c81918c0d88aa66cde6cd",
        "status": "owner_confirmed",
        "notCompleteIngredientList": true
      },
      "withdrawnImage": {
        "url": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-epos-047-lotus-reference.png?v=1792226252",
        "reason": "Owner withdrew image on 2026-10-17; use empty plate placeholder"
      }
    },
    {
      "id": "epos-048",
      "cat": "meat",
      "name": "酸菜鱼",
      "en": "Fish w/ Pickled Greens",
      "price": 3,
      "available": true,
      "sourceName": "酸菜鱼 (6pcs) Fish w/ Pickled Greens",
      "sourcePrice": 3,
      "portionEn": "6 pieces",
      "portionZh": "6 件",
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 125.35,
        "proteinG": 15.188,
        "fiberG": 0.64,
        "servingGrams": null,
        "servingGramsRange": [
          100,
          120
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "meat",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "edible_weight_unconfirmed",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            80,
            190
          ],
          "proteinG": [
            11.8,
            18.7
          ],
          "fiberG": [
            0.2,
            0.8
          ]
        },
        "assumptionsZh": [
          "鱼种未知，白肉鱼代理；保留6件鱼片，汤汁饮用量和鱼片净重未知。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。",
          "售卖规格保留6 件；未将件数/棵数换成已知克数。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": null,
        "calculationValuesPer100g": {
          "kcal": 125.35,
          "proteinG": 15.188,
          "fiberG": 0.64
        },
        "displayValuesPer100g": {
          "kcal": 125,
          "proteinG": 15.2,
          "fiberG": 0.6
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "previousImageReview": {
        "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-epos-048-lotus-reference.png?v=1792225953",
        "status": "superseded-awaiting-reference-revision",
        "sourceMessageId": "Sentinel_3492832fa76881919efbb407010e938b"
      },
      "withdrawnImage": {
        "url": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-epos-048-golden-broth-fish-owner-reference-v1.png?v=1792226659",
        "sourceMessageId": "Sentinel_fc3e8d8362348191a6a77567285507b6",
        "reason": "Owner rejected resemblance and appetite appeal; do not restore."
      },
      "image": ""
    },
    {
      "id": "epos-049",
      "cat": "meat",
      "name": "剁椒鱼",
      "en": "Steamed Fish with Chopped Chili",
      "price": 3,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-049-lotus-plate-v1.png?v=1792205431",
      "sourceName": "剁椒鱼 Steamed Fish with Chopped Chili",
      "sourcePrice": 3,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 125.95,
        "proteinG": 19.0484,
        "fiberG": 0.174,
        "servingGrams": 110,
        "servingGramsRange": [
          100,
          120
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "meat",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "assumed_cooked_edible_weight_unconfirmed",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            100,
            180
          ],
          "proteinG": [
            17.4,
            20.1
          ],
          "fiberG": [
            0.1,
            0.3
          ]
        },
        "assumptionsZh": [
          "白肉鱼代理；若带骨不得把骨头重量计入。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。",
          "AI预估：暂按110g熟制可食成菜（包括吃下的汁，不含骨）计算，未实秤；配方和用油仍是假设。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 110,
          "kcal": 140,
          "proteinG": 21,
          "fiberG": 0.2,
          "range": {
            "kcal": [
              100,
              216
            ],
            "proteinG": [
              17.4,
              24.1
            ],
            "fiberG": [
              0.1,
              0.4
            ]
          },
          "labelZh": "AI预估：暂按110g熟制可食成菜（包括吃下的汁，不含骨）计算，未实秤；配方和用油仍是假设。"
        },
        "calculationValuesPer100g": {
          "kcal": 125.95,
          "proteinG": 19.0484,
          "fiberG": 0.174
        },
        "displayValuesPer100g": {
          "kcal": 125,
          "proteinG": 19,
          "fiberG": 0.2
        },
        "servingDisclaimerEn": "AI estimate using 110g cooked edible portion (excluding bones); actual serving and recipe may differ."
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 2,
        "sourceMessageId": "Sentinel_f64d726a5030819189e91810d7d672a5",
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-049.jpg?v=1791937618",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_6a3ceeab0fb0819184da3e5ba30a0fd0",
        "shopifyFileId": "gid://shopify/MediaImage/46505128886514",
        "sourceSha256": "9e53690a6362fc0f90f29124654467fb092ff0b34b5326a84d69bd373618d148",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-050",
      "cat": "meat",
      "name": "咖喱鸡",
      "en": "Curry Chicken",
      "price": 3,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-050-lotus-plate-v1.png?v=1792205443",
      "sourceName": "咖喱鸡 Curry Chicken",
      "sourcePrice": 3,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 215.08,
        "proteinG": 14.7946,
        "fiberG": 0.676,
        "servingGrams": 110,
        "servingGramsRange": [
          100,
          120
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "meat",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "assumed_cooked_edible_weight_unconfirmed",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            155,
            245
          ],
          "proteinG": [
            14.5,
            17
          ],
          "fiberG": [
            0.5,
            0.7
          ]
        },
        "assumptionsZh": [
          "假设含椰浆和土豆；香料用红椒代理少量宏量营养，不代表配料表。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。",
          "AI预估：暂按110g熟制可食成菜（包括吃下的汁，不含骨）计算，未实秤；配方和用油仍是假设。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 110,
          "kcal": 235,
          "proteinG": 16.3,
          "fiberG": 0.7,
          "range": {
            "kcal": [
              155,
              294
            ],
            "proteinG": [
              14.5,
              20.4
            ],
            "fiberG": [
              0.5,
              0.8
            ]
          },
          "labelZh": "AI预估：暂按110g熟制可食成菜（包括吃下的汁，不含骨）计算，未实秤；配方和用油仍是假设。"
        },
        "calculationValuesPer100g": {
          "kcal": 215.08,
          "proteinG": 14.7946,
          "fiberG": 0.676
        },
        "displayValuesPer100g": {
          "kcal": 215,
          "proteinG": 14.8,
          "fiberG": 0.7
        },
        "servingDisclaimerEn": "AI estimate using 110g cooked edible portion (excluding bones); actual serving and recipe may differ."
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 1,
        "sourceMessageId": "Sentinel_f64d726a5030819189e91810d7d672a5",
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-050.jpg?v=1791937632",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_f05dd0fbfa5c8191b757781fd98931f3",
        "shopifyFileId": "gid://shopify/MediaImage/46505129246962",
        "sourceSha256": "dc4aacaa5325d15f78043a23841c9aa6f340dbbf29f62df9bed8367dab6959c2",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-051",
      "cat": "meat",
      "name": "三杯鸡",
      "en": "Three-Cup Chicken",
      "price": 3,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-051-lotus-plate-v1.png?v=1792205455",
      "sourceName": "三杯鸡 Three-Cup Chicken",
      "sourcePrice": 3,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 257.24,
        "proteinG": 18.227,
        "fiberG": 0.191,
        "servingGrams": 110,
        "servingGramsRange": [
          100,
          120
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "meat",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "assumed_cooked_edible_weight_unconfirmed",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            185,
            275
          ],
          "proteinG": [
            18.2,
            19.3
          ],
          "fiberG": [
            0,
            0.3
          ]
        },
        "assumptionsZh": [
          "酒未按固定残留量计入，实际留酒会使能量增加；不作无酒精承诺。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。",
          "AI预估：暂按110g熟制可食成菜（包括吃下的汁，不含骨）计算，未实秤；配方和用油仍是假设。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 110,
          "kcal": 285,
          "proteinG": 20,
          "fiberG": 0.2,
          "range": {
            "kcal": [
              185,
              330
            ],
            "proteinG": [
              18.2,
              23.2
            ],
            "fiberG": [
              0,
              0.4
            ]
          },
          "labelZh": "AI预估：暂按110g熟制可食成菜（包括吃下的汁，不含骨）计算，未实秤；配方和用油仍是假设。"
        },
        "calculationValuesPer100g": {
          "kcal": 257.24,
          "proteinG": 18.227,
          "fiberG": 0.191
        },
        "displayValuesPer100g": {
          "kcal": 255,
          "proteinG": 18.2,
          "fiberG": 0.2
        },
        "servingDisclaimerEn": "AI estimate using 110g cooked edible portion (excluding bones); actual serving and recipe may differ."
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-051.jpg?v=1791937643",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_c0259ba601a0819190563b80e955bec3",
        "shopifyFileId": "gid://shopify/MediaImage/46505129672946",
        "sourceSha256": "03b852b04157d2b87302021450834ee367baa28aa82987a5c84285862e51399a",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-052",
      "cat": "meat",
      "name": "宫保鸡",
      "en": "Kung Pao Chicken",
      "price": 3,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-052-kung-pao-chicken-landscape-v1.png?v=1792205163",
      "sourceName": "宫保鸡 Kung Pao Chicken",
      "sourcePrice": 3,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 250.79,
        "proteinG": 18.5614,
        "fiberG": 0.86,
        "servingGrams": 110,
        "servingGramsRange": [
          100,
          120
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "meat",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "assumed_category_midpoint",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            185,
            330
          ],
          "proteinG": [
            16.3,
            18.6
          ],
          "fiberG": [
            0.6,
            1
          ]
        },
        "assumptionsZh": [
          "花生为标准宫保情景假设，不能作为已核实过敏原申报。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 110,
          "kcal": 275,
          "proteinG": 20.4,
          "fiberG": 0.9,
          "range": {
            "kcal": [
              185,
              395
            ],
            "proteinG": [
              16.3,
              22.3
            ],
            "fiberG": [
              0.6,
              1.2
            ]
          },
          "labelZh": "AI预估，按约110g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 250.79,
          "proteinG": 18.5614,
          "fiberG": 0.86
        },
        "displayValuesPer100g": {
          "kcal": 250,
          "proteinG": 18.6,
          "fiberG": 0.9
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 1,
        "sourceMessageId": "Sentinel_f64d726a5030819189e91810d7d672a5",
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-052.jpg?v=1791937653",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_b01adf14870c81918dc2e701681eb37b",
        "shopifyFileId": "gid://shopify/MediaImage/46505116827890",
        "sourceSha256": "1858a3a11315969c1156eb274ce07e94f6851a57973e05c9e8e7d0738139cb94",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-053",
      "cat": "meat",
      "name": "姜葱鱼片",
      "en": "Ginger & Scallion Fish Slices",
      "price": 3,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-053-lotus-plate-v1.png?v=1792205501",
      "sourceName": "姜葱鱼片 Ginger & Scallion Fish Slices",
      "sourcePrice": 3,
      "nutrition": {
        "basis": "per_100g",
        "status": "ai_estimate",
        "labelZh": "AI预估",
        "kcal": 141.3,
        "proteinG": 17.5977,
        "fiberG": 0.269,
        "servingGrams": 110,
        "servingGramsRange": [
          100,
          120
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "meat",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "assumed_category_midpoint",
        "source": "Official food-composition ingredient data + explicitly assumed recipe scenarios; not restaurant laboratory data",
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "low",
        "rangePer100g": {
          "kcal": [
            110,
            205
          ],
          "proteinG": [
            17.4,
            18.3
          ],
          "fiberG": [
            0.2,
            0.3
          ]
        },
        "assumptionsZh": [
          "鱼种、裹粉和过油处理未知。",
          "食材比例、油和酱汁为AI模型假设，非店家确认配方。",
          "每100g指吃下的熟制可食成菜（包括吃下的汁），不含骨、虾壳或包装。"
        ],
        "sourceIds": [
          "usda_sr_2018"
        ],
        "perServingEstimate": {
          "assumedGrams": 110,
          "kcal": 155,
          "proteinG": 19.4,
          "fiberG": 0.3,
          "range": {
            "kcal": [
              110,
              245
            ],
            "proteinG": [
              17.4,
              21.9
            ],
            "fiberG": [
              0.2,
              0.4
            ]
          },
          "labelZh": "AI预估，按约110g熟制可食部假设"
        },
        "calculationValuesPer100g": {
          "kcal": 141.3,
          "proteinG": 17.5977,
          "fiberG": 0.269
        },
        "displayValuesPer100g": {
          "kcal": 140,
          "proteinG": 17.6,
          "fiberG": 0.3
        }
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-053.jpg?v=1791937664",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_406579e6467c8191baaa19b7a01e76f3",
        "shopifyFileId": "gid://shopify/MediaImage/46505131606258",
        "sourceSha256": "68bdedd7cac1f9bd8007a9b5bd96b64c18d09a70741ef1125e9c4852719bd62a",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    },
    {
      "id": "epos-054",
      "cat": "meat",
      "name": "麻坡鱼乌打",
      "en": "Muar Fish Otah",
      "price": 3,
      "available": true,
      "image": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-approved-epos-054-lotus-plate-v1.png?v=1792205488",
      "sourceName": "麻坡鱼乌打 Muar Fish Otah",
      "sourcePrice": 3,
      "nutrition": {
        "basis": "per_100g",
        "status": "pending",
        "labelZh": "待补配方",
        "kcal": null,
        "proteinG": null,
        "fiberG": null,
        "servingGrams": null,
        "servingGramsRange": [
          100,
          120
        ],
        "servingRangeBasis": "Owner requested dishes 80g, eggs 60–80g (70g midpoint), meat 100–120g (110g midpoint); cooked edible-weight interpretation remains an assumption, not a measured serving",
        "servingAssumptionCategory": "meat",
        "servingInstructionMessageId": "Sentinel_677f5f4e7bf88191be3a18facdf961eb",
        "servingWeightStatus": "assumed_category_midpoint",
        "source": null,
        "reviewedAt": null,
        "estimatedAt": "2026-10-16",
        "confidence": "unknown",
        "rangePer100g": null,
        "assumptionsZh": [
          "请提供鱼乌打品牌标签或鱼肉、椰浆、蛋/淀粉配方及每份熟重。"
        ],
        "sourceIds": [],
        "perServingEstimate": null
      },
      "spiciness": {
        "status": "owner_confirmed",
        "level": 0,
        "canMakeNonSpicy": null,
        "maxLevel": 5,
        "sourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03",
        "scaleSourceMessageId": "Sentinel_b6dcc91df248819187903d0dc142cd03"
      },
      "originalImage": "https://cdn.shopify.com/s/files/1/0683/3504/2802/files/mafe-cbd-epos-054.jpg?v=1791937676",
      "imageKind": "reference",
      "imageAspect": "3:2",
      "imageAspectRatio": "3 / 2",
      "imageFit": "cover",
      "imageSourceType": "owner_approved_ai_reference",
      "imageSource": {
        "type": "owner_approved_ai_reference",
        "libraryFileId": "libfile_9a51e157c0348191b5b3a1c234c186c1",
        "shopifyFileId": "gid://shopify/MediaImage/46505131049202",
        "sourceSha256": "943b36aa196c7a20155d73478ee369dd790a98d62a00c23d3504c4313a0211dc",
        "integratedAt": "2026-10-17",
        "approvalMessageId": "Sentinel_3fc3bdbf3c5881918513cd83574d8e2d"
      }
    }
  ],
  "nutritionSources": [
    {
      "id": "usda_sr_2018",
      "title": "USDA FoodData Central, SR Legacy April 2018 JSON",
      "url": "https://fdc.nal.usda.gov/fdc-datasets/FoodData_Central_sr_legacy_food_json_2018-04.zip",
      "catalogUrl": "https://fdc.nal.usda.gov/download-datasets/",
      "retrievedAt": "2026-10-16",
      "sha256": "0fe8ae486a2c8eb42cb96413f058deb51863a46c8fb8eeb4b1fb45006dd338ef",
      "noteZh": "逐项从原始JSON读取营养1008能量kcal、1003蛋白g、1079总膳食纤维g；以fdcId追溯。"
    },
    {
      "id": "usda_fndds_2024",
      "title": "USDA FoodData Central, FNDDS 2021–2023, October 2024 JSON",
      "url": "https://fdc.nal.usda.gov/fdc-datasets/FoodData_Central_survey_food_json_2024-10-31.zip",
      "catalogUrl": "https://fdc.nal.usda.gov/download-datasets/",
      "retrievedAt": "2026-10-16",
      "sha256": "dfb06ae7ddc397ccd570b91c14b75438ab2ba39f64f22d321f61d4a52a77f3eb",
      "noteZh": "本项目用于熟五花肉2705901，该条本身为官方通用配方模型。"
    },
    {
      "id": "cfs_food_search",
      "title": "香港食物安全中心 Nutrient Information Inquiry",
      "url": "https://www.cfs.gov.hk/english/nutrient/fc-search3.php",
      "retrievedAt": "2026-10-16",
      "noteZh": "经公开表单只读查询；来源项编号见ingredient.sourceLocator。菜心/豆苗来自CFS FRL；咸蛋/皮蛋/虾米/魟来自其CFC2002Ed2条目。后者缺失纤维没有直接填0，明确采用相近USDA动物性食物纤维0作模型。"
    },
    {
      "id": "cfs_vegetables_2007",
      "title": "香港食物安全中心 Nutrient Values of Fruit and Vegetables (2007)",
      "url": "https://www.cfs.gov.hk/english/programme/programme_rafs/files/fruit%20and%20veg%20report_7June07.pdf",
      "retrievedAt": "2026-10-16",
      "noteZh": "仅使用Annex V原料苋菜总纤维2.0g/100g作熟苋菜纤维近似。"
    },
    {
      "id": "mext_yuba_2023",
      "title": "日本文部科学省 日本食品标准成分表（八订）增补2023年：腐皮",
      "url": "https://fooddb.mext.go.jp/details/details.pl?ITEM_NO=4_04091_7&MODE=0&WEIGHT=100",
      "additionalUrls": [
        "https://fooddb.mext.go.jp/details/details.pl?ITEM_NO=4_04059_7&MODE=0&WEIGHT=100"
      ],
      "retrievedAt": "2026-10-16",
      "noteZh": "04091热水泡发腐皮每100g151kcal/蛋白15.7g/总膳食纤维1.2g；04059鲜腐皮218kcal/21.8g/0.8g。已直接读取官方网页，未把干重当熟重。"
    }
  ],
  "nutritionMethod": {
    "createdAt": "2026-10-16",
    "displayDisclaimerZh": "AI预估，按假设配方及份量计算，非实测。食材比例、用油、酱汁及实际分量会令数值变化。",
    "displayServingDisclaimerZh": "普通菜80g；蛋类60–80g暂按70g；肉类100–120g暂按110g。例外：罗汉斋、上汤枸杞鸡蛋娃娃菜按含汁120–150g的中点135g；招牌炸豆腐约50g，但配方营养仍待补。其他豆腐为主普通菜暂按80g。以上不是逐份实秤；其余按件、棵或带骨壳菜品净重仍待确认。",
    "rangeDisclaimerZh": "区间来自三组假设配方/含水量及份量变化，只是情景范围，不是统计置信区间或保证上下限。",
    "calculationRule": "For each nutrient: sum(final edible ingredient grams × ingredient per100g nutrient / 100). Scale unrounded per100g values by selected cooked edible grams / 100, sum first, then round kcal to nearest 5 and protein/fibre to 0.1 g. Do not convert null to zero.",
    "methodNotesZh": [
      "该模型以当前菜名识别常见食材，配方情景未经厨房确认，不称为店铺营养检测数据。",
      "原料代理与生熟换算分别写在ingredients中；植物油是实际保留在100g成菜中的油，不是下锅油总量。",
      "原料来源、各情景最终食材质量及营养合计均保留，便于厨师提供真实配方后替换。",
      "含水、肥瘦、油吸收和实际食材品种的不确定性可能超过展示情景范围。",
      "未评估钠、糖、脂肪、过敏原、素食或其他健康声称；不得由此宣称低脂、高蛋白、高纤或符合特定病情饮食。",
      "组合含待补配方或未确认可食克重菜品时，仅显示已估算部分/不完整估算，并列出未纳入项。"
    ]
  }
};
